//#region ../packet-preview-2026-09-07/node_modules/gsap/gsap-core.js
function e(e) {
	if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
function t(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var n = {
	autoSleep: 120,
	force3D: "auto",
	nullTargetWarn: 1,
	units: { lineHeight: "" }
}, r = {
	duration: .5,
	overwrite: !1,
	delay: 0
}, i, a, o, s = 1e8, c = 1 / s, l = Math.PI * 2, u = l / 4, d = 0, f = Math.sqrt, p = Math.cos, m = Math.sin, h = function(e) {
	return typeof e == "string";
}, g = function(e) {
	return typeof e == "function";
}, _ = function(e) {
	return typeof e == "number";
}, v = function(e) {
	return e === void 0;
}, y = function(e) {
	return typeof e == "object";
}, b = function(e) {
	return e !== !1;
}, x = function() {
	return typeof window < "u";
}, S = function(e) {
	return g(e) || h(e);
}, C = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {}, w = Array.isArray, T = /random\([^)]+\)/g, E = /,\s*/g, D = /(?:-?\.?\d|\.)+/gi, O = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, k = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, A = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, j = /[+-]=-?[.\d]+/, M = /[^,'"\[\]\s]+/gi, ee = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, N, P, te, ne, F = {}, re = {}, I, L = function(e) {
	return (re = G(e, F)) && Kn;
}, ie = function(e, t) {
	return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
}, R = function(e, t) {
	return !t && console.warn(e);
}, ae = function(e, t) {
	return e && (F[e] = t) && re && (re[e] = t) || F;
}, oe = function() {
	return 0;
}, se = {
	suppressEvents: !0,
	isStart: !0,
	kill: !1
}, z = {
	suppressEvents: !0,
	kill: !1
}, ce = { suppressEvents: !0 }, le = {}, B = [], ue = {}, de, fe = {}, pe = {}, me = 30, he = [], ge = "", _e = function(e) {
	var t = e[0], n, r;
	if (y(t) || g(t) || (e = [e]), !(n = (t._gsap || {}).harness)) {
		for (r = he.length; r-- && !he[r].targetTest(t););
		n = he[r];
	}
	for (r = e.length; r--;) e[r] && (e[r]._gsap || (e[r]._gsap = new tn(e[r], n))) || e.splice(r, 1);
	return e;
}, ve = function(e) {
	return e._gsap || _e(ut(e))[0]._gsap;
}, V = function(e, t, n) {
	return (n = e[t]) && g(n) ? e[t]() : v(n) && e.getAttribute && e.getAttribute(t) || n;
}, ye = function(e, t) {
	return (e = e.split(",")).forEach(t) || e;
}, H = function(e) {
	return Math.round(e * 1e5) / 1e5 || 0;
}, U = function(e) {
	return Math.round(e * 1e7) / 1e7 || 0;
}, be = function(e, t) {
	var n = t.charAt(0), r = parseFloat(t.substr(2));
	return e = parseFloat(e), n === "+" ? e + r : n === "-" ? e - r : n === "*" ? e * r : e / r;
}, xe = function(e, t) {
	for (var n = t.length, r = 0; e.indexOf(t[r]) < 0 && ++r < n;);
	return r < n;
}, Se = function() {
	var e = B.length, t = B.slice(0), n, r;
	for (ue = {}, B.length = 0, n = 0; n < e; n++) r = t[n], r && r._lazy && (r.render(r._lazy[0], r._lazy[1], !0)._lazy = 0);
}, Ce = function(e) {
	return !!(e._initted || e._startAt || e.add);
}, we = function(e, t, n, r) {
	B.length && !a && Se(), e.render(t, n, r || !!(a && t < 0 && Ce(e))), B.length && !a && Se();
}, Te = function(e) {
	var t = parseFloat(e);
	return (t || t === 0) && (e + "").match(M).length < 2 ? t : h(e) ? e.trim() : e;
}, Ee = function(e) {
	return e;
}, W = function(e, t) {
	for (var n in t) n in e || (e[n] = t[n]);
	return e;
}, De = function(e) {
	return function(t, n) {
		for (var r in n) r in t || r === "duration" && e || r === "ease" || (t[r] = n[r]);
	};
}, G = function(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}, Oe = function e(t, n) {
	for (var r in n) r !== "__proto__" && r !== "constructor" && r !== "prototype" && (t[r] = y(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
	return t;
}, ke = function(e, t) {
	var n = {}, r;
	for (r in e) r in t || (n[r] = e[r]);
	return n;
}, Ae = function(e) {
	var t = e.parent || N, n = e.keyframes ? De(w(e.keyframes)) : W;
	if (b(e.inherit)) for (; t;) n(e, t.vars.defaults), t = t.parent || t._dp;
	return e;
}, je = function(e, t) {
	for (var n = e.length, r = n === t.length; r && n-- && e[n] === t[n];);
	return n < 0;
}, Me = function(e, t, n, r, i) {
	n === void 0 && (n = "_first"), r === void 0 && (r = "_last");
	var a = e[r], o;
	if (i) for (o = t[i]; a && a[i] > o;) a = a._prev;
	return a ? (t._next = a._next, a._next = t) : (t._next = e[n], e[n] = t), t._next ? t._next._prev = t : e[r] = t, t._prev = a, t.parent = t._dp = e, t;
}, Ne = function(e, t, n, r) {
	n === void 0 && (n = "_first"), r === void 0 && (r = "_last");
	var i = t._prev, a = t._next;
	i ? i._next = a : e[n] === t && (e[n] = a), a ? a._prev = i : e[r] === t && (e[r] = i), t._next = t._prev = t.parent = null;
}, Pe = function(e, t) {
	e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, Fe = function(e, t) {
	if (e && (!t || t._end > e._dur || t._start < 0)) for (var n = e; n;) n._dirty = 1, n = n.parent;
	return e;
}, Ie = function(e) {
	for (var t = e.parent; t && t.parent;) t._dirty = 1, t.totalDuration(), t = t.parent;
	return e;
}, Le = function(e, t, n, r) {
	return e._startAt && (a ? e._startAt.revert(z) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, r));
}, Re = function e(t) {
	return !t || t._ts && e(t.parent);
}, ze = function(e) {
	return e._repeat ? Be(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Be = function(e, t) {
	var n = Math.floor(e = U(e / t));
	return e && n === e ? n - 1 : n;
}, Ve = function(e, t) {
	return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
}, He = function(e) {
	return e._end = U(e._start + (e._tDur / Math.abs(e._ts || e._rts || c) || 0));
}, Ue = function(e, t) {
	var n = e._dp;
	return n && n.smoothChildTiming && e._ts && (e._start = U(n._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), He(e), n._dirty || Fe(n, e)), e;
}, We = function(e, t) {
	var n;
	if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (n = Ve(e.rawTime(), t), (!t._dur || it(0, t.totalDuration(), n) - t._tTime > c) && t.render(n, !0)), Fe(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
		if (e._dur < e.duration()) for (n = e; n._dp;) n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
		e._zTime = -c;
	}
}, Ge = function(e, t, n, r) {
	return t.parent && Pe(t), t._start = U((_(n) ? n : n || e !== N ? tt(e, n, t) : e._time) + t._delay), t._end = U(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Me(e, t, "_first", "_last", e._sort ? "_start" : 0), Ye(t) || (e._recent = t), r || We(e, t), e._ts < 0 && Ue(e, e._tTime), e;
}, Ke = function(e, t) {
	return (F.ScrollTrigger || ie("scrollTrigger", t)) && F.ScrollTrigger.create(t, e);
}, qe = function(e, t, n, r, i) {
	if (dn(e, t, i), !e._initted) return 1;
	if (!n && e._pt && !a && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && de !== Ht.frame) return B.push(e), e._lazy = [i, r], 1;
}, Je = function e(t) {
	var n = t.parent;
	return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n));
}, Ye = function(e) {
	var t = e.data;
	return t === "isFromStart" || t === "isStart";
}, Xe = function(e, t, n, r) {
	var i = e.ratio, o = t < 0 || !t && (!e._start && Je(e) && (e._initted || !Ye(e)) || (e._ts < 0 || e._dp._ts < 0) && !Ye(e)) ? 0 : 1, s = e._rDelay, l = 0, u, d, f;
	if (s && e._repeat && (l = it(0, e._tDur, t), d = Be(l, s), e._yoyo && d & 1 && (o = 1 - o), d !== Be(e._tTime, s) && (i = 1 - o, e.vars.repeatRefresh && e._initted && e.invalidate())), o !== i || a || r || e._zTime === c || !t && e._zTime) {
		if (!e._initted && qe(e, t, r, n, l)) return;
		for (f = e._zTime, e._zTime = t || (n ? c : 0), n ||= t && !f, e.ratio = o, e._from && (o = 1 - o), e._time = 0, e._tTime = l, u = e._pt; u;) u.r(o, u.d), u = u._next;
		t < 0 && Le(e, t, n, !0), e._onUpdate && !n && Dt(e, "onUpdate"), l && e._repeat && !n && e.parent && Dt(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === o && (o && Pe(e, 1), !n && !a && (Dt(e, o ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
	} else e._zTime ||= t;
}, Ze = function(e, t, n) {
	var r;
	if (n > t) for (r = e._first; r && r._start <= n;) {
		if (r.data === "isPause" && r._start > t) return r;
		r = r._next;
	}
	else for (r = e._last; r && r._start >= n;) {
		if (r.data === "isPause" && r._start < t) return r;
		r = r._prev;
	}
}, Qe = function(e, t, n, r) {
	var i = e._repeat, a = U(t) || 0, o = e._tTime / e._tDur;
	return o && !r && (e._time *= a / e._dur), e._dur = a, e._tDur = i ? i < 0 ? 1e10 : U(a * (i + 1) + e._rDelay * i) : a, o > 0 && !r && Ue(e, e._tTime = e._tDur * o), e.parent && He(e), n || Fe(e.parent, e), e;
}, $e = function(e) {
	return e instanceof rn ? Fe(e) : Qe(e, e._dur);
}, et = {
	_start: 0,
	endTime: oe,
	totalDuration: oe
}, tt = function e(t, n, r) {
	var i = t.labels, a = t._recent || et, o = t.duration() >= s ? a.endTime(!1) : t._dur, c, l, u;
	return h(n) && (isNaN(n) || n in i) ? (l = n.charAt(0), u = n.substr(-1) === "%", c = n.indexOf("="), l === "<" || l === ">" ? (c >= 0 && (n = n.replace(/=/, "")), (l === "<" ? a._start : a.endTime(a._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (u ? (c < 0 ? a : r).totalDuration() / 100 : 1)) : c < 0 ? (n in i || (i[n] = o), i[n]) : (l = parseFloat(n.charAt(c - 1) + n.substr(c + 1)), u && r && (l = l / 100 * (w(r) ? r[0] : r).totalDuration()), c > 1 ? e(t, n.substr(0, c - 1), r) + l : o + l)) : n == null ? o : +n;
}, nt = function(e, t, n) {
	var r = _(t[1]), i = (r ? 2 : 1) + (e < 2 ? 0 : 1), a = t[i], o, s;
	if (r && (a.duration = t[1]), a.parent = n, e) {
		for (o = a, s = n; s && !("immediateRender" in o);) o = s.vars.defaults || {}, s = b(s.vars.inherit) && s.parent;
		a.immediateRender = b(o.immediateRender), e < 2 ? a.runBackwards = 1 : a.startAt = t[i - 1];
	}
	return new vn(t[0], a, t[i + 1]);
}, rt = function(e, t) {
	return e || e === 0 ? t(e) : t;
}, it = function(e, t, n) {
	return n < e ? e : n > t ? t : n;
}, at = function(e, t) {
	return !h(e) || !(t = ee.exec(e)) ? "" : t[1];
}, ot = function(e, t, n) {
	return rt(n, function(n) {
		return it(e, t, n);
	});
}, st = [].slice, ct = function(e, t) {
	return e && y(e) && "length" in e && (!t && !e.length || e.length - 1 in e && y(e[0])) && !e.nodeType && e !== P;
}, lt = function(e, t, n) {
	return n === void 0 && (n = []), e.forEach(function(e) {
		var r;
		return h(e) && !t || ct(e, 1) ? (r = n).push.apply(r, ut(e)) : n.push(e);
	}) || n;
}, ut = function(e, t, n) {
	return o && !t && o.selector ? o.selector(e) : h(e) && !n && (te || !Ut()) ? st.call((t || ne).querySelectorAll(e), 0) : w(e) ? lt(e, n) : ct(e) ? st.call(e, 0) : e ? [e] : [];
}, dt = function(e) {
	return e = ut(e)[0] || R("Invalid scope") || {}, function(t) {
		var n = e.current || e.nativeElement || e;
		return ut(t, n.querySelectorAll ? n : n === e ? R("Invalid scope") || ne.createElement("div") : e);
	};
}, ft = function(e) {
	return e.sort(function() {
		return .5 - Math.random();
	});
}, pt = function(e) {
	if (g(e)) return e;
	var t = y(e) ? e : { each: e }, n = Xt(t.ease), r = t.from || 0, i = parseFloat(t.base) || 0, a = {}, o = r > 0 && r < 1, c = isNaN(r) || o, l = t.axis, u = r, d = r;
	return h(r) ? u = d = {
		center: .5,
		edges: .5,
		end: 1
	}[r] || 0 : !o && c && (u = r[0], d = r[1]), function(e, o, p) {
		var m = (p || t).length, h = a[m], g, _, v, y, b, x, S, C, w;
		if (!h) {
			if (w = t.grid === "auto" ? 0 : (t.grid || [1, s])[1], !w) {
				for (S = -s; S < (S = p[w++].getBoundingClientRect().left) && w < m;);
				w < m && w--;
			}
			for (h = a[m] = [], g = c ? Math.min(w, m) * u - .5 : r % w, _ = w === s ? 0 : c ? m * d / w - .5 : r / w | 0, S = 0, C = s, x = 0; x < m; x++) v = x % w - g, y = _ - (x / w | 0), h[x] = b = l ? Math.abs(l === "y" ? y : v) : f(v * v + y * y), b > S && (S = b), b < C && (C = b);
			r === "random" && ft(h), h.max = S - C, h.min = C, h.v = m = (parseFloat(t.amount) || parseFloat(t.each) * (w > m ? m - 1 : l ? l === "y" ? m / w : w : Math.max(w, m / w)) || 0) * (r === "edges" ? -1 : 1), h.b = m < 0 ? i - m : i, h.u = at(t.amount || t.each) || 0, n = n && m < 0 ? Yt(n) : n;
		}
		return m = (h[e] - h.min) / h.max || 0, U(h.b + (n ? n(m) : m) * h.v) + h.u;
	};
}, mt = function(e) {
	var t = 10 ** ((e + "").split(".")[1] || "").length;
	return function(n) {
		var r = U(Math.round(parseFloat(n) / e) * e * t);
		return (r - r % 1) / t + (_(n) ? 0 : at(n));
	};
}, ht = function(e, t) {
	var n = w(e), r, i;
	return !n && y(e) && (r = n = e.radius || s, e.values ? (e = ut(e.values), (i = !_(e[0])) && (r *= r)) : e = mt(e.increment)), rt(t, n ? g(e) ? function(t) {
		return i = e(t), Math.abs(i - t) <= r ? i : t;
	} : function(t) {
		for (var n = parseFloat(i ? t.x : t), a = parseFloat(i ? t.y : 0), o = s, c = 0, l = e.length, u, d; l--;) i ? (u = e[l].x - n, d = e[l].y - a, u = u * u + d * d) : u = Math.abs(e[l] - n), u < o && (o = u, c = l);
		return c = !r || o <= r ? e[c] : t, i || c === t || _(t) ? c : c + at(t);
	} : mt(e));
}, gt = function(e, t, n, r) {
	return rt(w(e) ? !t : n === !0 ? !!(n = 0) : !r, function() {
		return w(e) ? e[~~(Math.random() * e.length)] : (n ||= 1e-5) && (r = n < 1 ? 10 ** ((n + "").length - 2) : 1) && Math.floor(Math.round((e - n / 2 + Math.random() * (t - e + n * .99)) / n) * n * r) / r;
	});
}, _t = function() {
	var e = [...arguments];
	return function(t) {
		return e.reduce(function(e, t) {
			return t(e);
		}, t);
	};
}, vt = function(e, t) {
	return function(n) {
		return e(parseFloat(n)) + (t || at(n));
	};
}, yt = function(e, t, n) {
	return wt(e, t, 0, 1, n);
}, bt = function(e, t, n) {
	return rt(n, function(n) {
		return e[~~t(n)];
	});
}, xt = function e(t, n, r) {
	var i = n - t;
	return w(t) ? bt(t, e(0, t.length), n) : rt(r, function(e) {
		return (i + (e - t) % i) % i + t;
	});
}, St = function e(t, n, r) {
	var i = n - t, a = i * 2;
	return w(t) ? bt(t, e(0, t.length - 1), n) : rt(r, function(e) {
		return e = (a + (e - t) % a) % a || 0, t + (e > i ? a - e : e);
	});
}, Ct = function(e) {
	return e.replace(T, function(e) {
		var t = e.indexOf("[") + 1, n = e.substring(t || 7, t ? e.indexOf("]") : e.length - 1).split(E);
		return gt(t ? n : +n[0], t ? 0 : +n[1], +n[2] || 1e-5);
	});
}, wt = function(e, t, n, r, i) {
	var a = t - e, o = r - n;
	return rt(i, function(t) {
		return n + ((t - e) / a * o || 0);
	});
}, Tt = function e(t, n, r, i) {
	var a = isNaN(t + n) ? 0 : function(e) {
		return (1 - e) * t + e * n;
	};
	if (!a) {
		var o = h(t), s = {}, c, l, u, d, f;
		if (r === !0 && (i = 1) && (r = null), o) t = { p: t }, n = { p: n };
		else if (w(t) && !w(n)) {
			for (u = [], d = t.length, f = d - 2, l = 1; l < d; l++) u.push(e(t[l - 1], t[l]));
			d--, a = function(e) {
				e *= d;
				var t = Math.min(f, ~~e);
				return u[t](e - t);
			}, r = n;
		} else i || (t = G(w(t) ? [] : {}, t));
		if (!u) {
			for (c in n) on.call(s, t, c, "get", n[c]);
			a = function(e) {
				return Dn(e, s) || (o ? t.p : t);
			};
		}
	}
	return rt(r, a);
}, Et = function(e, t, n) {
	var r = e.labels, i = s, a, o, c;
	for (a in r) o = r[a] - t, o < 0 == !!n && o && i > (o = Math.abs(o)) && (c = a, i = o);
	return c;
}, Dt = function(e, t, n) {
	var r = e.vars, i = r[t], a = o, s = e._ctx, c, l, u;
	if (i) return c = r[t + "Params"], l = r.callbackScope || e, n && B.length && Se(), s && (o = s), u = c ? i.apply(l, c) : i.call(l), o = a, u;
}, Ot = function(e) {
	return Pe(e), e.scrollTrigger && e.scrollTrigger.kill(!!a), e.progress() < 1 && Dt(e, "onInterrupt"), e;
}, kt, At = [], jt = function(e) {
	if (e) {
		if (e = !e.name && e.default || e, x() || e.headless) {
			var t = e.name, n = g(e), r = t && !n && e.init ? function() {
				this._props = [];
			} : e, i = {
				init: oe,
				render: Dn,
				add: on,
				kill: kn,
				modifier: On,
				rawVars: 0
			}, a = {
				targetTest: 0,
				get: 0,
				getSetter: Cn,
				aliases: {},
				register: 0
			};
			if (Ut(), e !== r) {
				if (fe[t]) return;
				W(r, W(ke(e, i), a)), G(r.prototype, G(i, ke(e, a))), fe[r.prop = t] = r, e.targetTest && (he.push(r), le[t] = 1), t = (t === "css" ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
			}
			ae(t, r), e.register && e.register(Kn, r, Mn);
		} else At.push(e);
	}
}, Mt = 255, Nt = {
	aqua: [
		0,
		Mt,
		Mt
	],
	lime: [
		0,
		Mt,
		0
	],
	silver: [
		192,
		192,
		192
	],
	black: [
		0,
		0,
		0
	],
	maroon: [
		128,
		0,
		0
	],
	teal: [
		0,
		128,
		128
	],
	blue: [
		0,
		0,
		Mt
	],
	navy: [
		0,
		0,
		128
	],
	white: [
		Mt,
		Mt,
		Mt
	],
	olive: [
		128,
		128,
		0
	],
	yellow: [
		Mt,
		Mt,
		0
	],
	orange: [
		Mt,
		165,
		0
	],
	gray: [
		128,
		128,
		128
	],
	purple: [
		128,
		0,
		128
	],
	green: [
		0,
		128,
		0
	],
	red: [
		Mt,
		0,
		0
	],
	pink: [
		Mt,
		192,
		203
	],
	cyan: [
		0,
		Mt,
		Mt
	],
	transparent: [
		Mt,
		Mt,
		Mt,
		0
	]
}, Pt = function(e, t, n) {
	return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? t + (n - t) * e * 6 : e < .5 ? n : e * 3 < 2 ? t + (n - t) * (2 / 3 - e) * 6 : t) * Mt + .5 | 0;
}, Ft = function(e, t, n) {
	var r = e ? _(e) ? [
		e >> 16,
		e >> 8 & Mt,
		e & Mt
	] : 0 : Nt.black, i, a, o, s, c, l, u, d, f, p;
	if (!r) {
		if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), Nt[e]) r = Nt[e];
		else if (e.charAt(0) === "#") {
			if (e.length < 6 && (i = e.charAt(1), a = e.charAt(2), o = e.charAt(3), e = "#" + i + i + a + a + o + o + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9) return r = parseInt(e.substr(1, 6), 16), [
				r >> 16,
				r >> 8 & Mt,
				r & Mt,
				parseInt(e.substr(7), 16) / 255
			];
			e = parseInt(e.substr(1), 16), r = [
				e >> 16,
				e >> 8 & Mt,
				e & Mt
			];
		} else if (e.substr(0, 3) === "hsl") {
			if (r = p = e.match(D), !t) s = r[0] % 360 / 360, c = r[1] / 100, l = r[2] / 100, a = l <= .5 ? l * (c + 1) : l + c - l * c, i = l * 2 - a, r.length > 3 && (r[3] *= 1), r[0] = Pt(s + 1 / 3, i, a), r[1] = Pt(s, i, a), r[2] = Pt(s - 1 / 3, i, a);
			else if (~e.indexOf("=")) return r = e.match(O), n && r.length < 4 && (r[3] = 1), r;
		} else r = e.match(D) || Nt.transparent;
		r = r.map(Number);
	}
	return t && !p && (i = r[0] / Mt, a = r[1] / Mt, o = r[2] / Mt, u = Math.max(i, a, o), d = Math.min(i, a, o), l = (u + d) / 2, u === d ? s = c = 0 : (f = u - d, c = l > .5 ? f / (2 - u - d) : f / (u + d), s = u === i ? (a - o) / f + (a < o ? 6 : 0) : u === a ? (o - i) / f + 2 : (i - a) / f + 4, s *= 60), r[0] = ~~(s + .5), r[1] = ~~(c * 100 + .5), r[2] = ~~(l * 100 + .5)), n && r.length < 4 && (r[3] = 1), r;
}, It = function(e) {
	var t = [], n = [], r = -1;
	return e.split(Rt).forEach(function(e) {
		var i = e.match(k) || [];
		t.push.apply(t, i), n.push(r += i.length + 1);
	}), t.c = n, t;
}, Lt = function(e, t, n) {
	var r = "", i = (e + r).match(Rt), a = t ? "hsla(" : "rgba(", o = 0, s, c, l, u;
	if (!i) return e;
	if (i = i.map(function(e) {
		return (e = Ft(e, t, 1)) && a + (t ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3] : e.join(",")) + ")";
	}), n && (l = It(e), s = n.c, s.join(r) !== l.c.join(r))) for (c = e.replace(Rt, "1").split(k), u = c.length - 1; o < u; o++) r += c[o] + (~s.indexOf(o) ? i.shift() || a + "0,0,0,0)" : (l.length ? l : i.length ? i : n).shift());
	if (!c) for (c = e.split(Rt), u = c.length - 1; o < u; o++) r += c[o] + i[o];
	return r + c[u];
}, Rt = function() {
	var e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
	for (t in Nt) e += "|" + t + "\\b";
	return RegExp(e + ")", "gi");
}(), zt = /hsl[a]?\(/, Bt = function(e) {
	var t = e.join(" "), n;
	if (Rt.lastIndex = 0, Rt.test(t)) return n = zt.test(t), e[1] = Lt(e[1], n), e[0] = Lt(e[0], n, It(e[1])), !0;
}, Vt, Ht = function() {
	var e = Date.now, t = 500, n = 33, r = e(), i = r, a = 1e3 / 240, o = a, s = [], c, l, u, d, f, p, m = function u(m) {
		var h = e() - i, g = m === !0, _, v, y, b;
		if ((h > t || h < 0) && (r += h - n), i += h, y = i - r, _ = y - o, (_ > 0 || g) && (b = ++d.frame, f = y - d.time * 1e3, d.time = y /= 1e3, o += _ + (_ >= a ? 4 : a - _), v = 1), g || (c = l(u)), v) for (p = 0; p < s.length; p++) s[p](y, f, b, m);
	};
	return d = {
		time: 0,
		frame: 0,
		tick: function() {
			m(!0);
		},
		deltaRatio: function(e) {
			return f / (1e3 / (e || 60));
		},
		wake: function() {
			I && (!te && x() && (P = te = window, ne = P.document || {}, F.gsap = Kn, (P.gsapVersions || (P.gsapVersions = [])).push(Kn.version), L(re || P.GreenSockGlobals || !P.gsap && P || {}), At.forEach(jt)), u = typeof requestAnimationFrame < "u" && requestAnimationFrame, c && d.sleep(), l = u || function(e) {
				return setTimeout(e, o - d.time * 1e3 + 1 | 0);
			}, Vt = 1, m(2));
		},
		sleep: function() {
			(u ? cancelAnimationFrame : clearTimeout)(c), Vt = 0, l = oe;
		},
		lagSmoothing: function(e, r) {
			t = e || Infinity, n = Math.min(r || 33, t);
		},
		fps: function(e) {
			a = 1e3 / (e || 240), o = d.time * 1e3 + a;
		},
		add: function(e, t, n) {
			var r = t ? function(t, n, i, a) {
				e(t, n, i, a), d.remove(r);
			} : e;
			return d.remove(e), s[n ? "unshift" : "push"](r), Ut(), r;
		},
		remove: function(e, t) {
			~(t = s.indexOf(e)) && s.splice(t, 1) && p >= t && p--;
		},
		_listeners: s
	}, d;
}(), Ut = function() {
	return !Vt && Ht.wake();
}, K = {}, Wt = /^[\d.\-M][\d.\-,\s]/, Gt = /["']/g, Kt = function(e) {
	for (var t = {}, n = e.substr(1, e.length - 3).split(":"), r = n[0], i = 1, a = n.length, o, s, c; i < a; i++) s = n[i], o = i === a - 1 ? s.length : s.lastIndexOf(","), c = s.substr(0, o), t[r] = isNaN(c) ? c.replace(Gt, "").trim() : +c, r = s.substr(o + 1).trim();
	return t;
}, qt = function(e) {
	var t = e.indexOf("(") + 1, n = e.indexOf(")"), r = e.indexOf("(", t);
	return e.substring(t, ~r && r < n ? e.indexOf(")", n + 1) : n);
}, Jt = function(e) {
	var t = (e + "").split("("), n = K[t[0]];
	return n && t.length > 1 && n.config ? n.config.apply(null, ~e.indexOf("{") ? [Kt(t[1])] : qt(e).split(",").map(Te)) : K._CE && Wt.test(e) ? K._CE("", e) : n;
}, Yt = function(e) {
	return function(t) {
		return 1 - e(1 - t);
	};
}, Xt = function(e, t) {
	return e && (g(e) ? e : K[e] || Jt(e)) || t;
}, Zt = function(e, t, n, r) {
	n === void 0 && (n = function(e) {
		return 1 - t(1 - e);
	}), r === void 0 && (r = function(e) {
		return e < .5 ? t(e * 2) / 2 : 1 - t((1 - e) * 2) / 2;
	});
	var i = {
		easeIn: t,
		easeOut: n,
		easeInOut: r
	}, a;
	return ye(e, function(e) {
		for (var t in K[e] = F[e] = i, K[a = e.toLowerCase()] = n, i) K[a + (t === "easeIn" ? ".in" : t === "easeOut" ? ".out" : ".inOut")] = K[e + "." + t] = i[t];
	}), i;
}, Qt = function(e) {
	return function(t) {
		return t < .5 ? (1 - e(1 - t * 2)) / 2 : .5 + e((t - .5) * 2) / 2;
	};
}, $t = function e(t, n, r) {
	var i = n >= 1 ? n : 1, a = (r || (t ? .3 : .45)) / (n < 1 ? n : 1), o = a / l * (Math.asin(1 / i) || 0), s = function(e) {
		return e === 1 ? 1 : i * 2 ** (-10 * e) * m((e - o) * a) + 1;
	}, c = t === "out" ? s : t === "in" ? function(e) {
		return 1 - s(1 - e);
	} : Qt(s);
	return a = l / a, c.config = function(n, r) {
		return e(t, n, r);
	}, c;
}, en = function e(t, n) {
	n === void 0 && (n = 1.70158);
	var r = function(e) {
		return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
	}, i = t === "out" ? r : t === "in" ? function(e) {
		return 1 - r(1 - e);
	} : Qt(r);
	return i.config = function(n) {
		return e(t, n);
	}, i;
};
ye("Linear,Quad,Cubic,Quart,Quint,Strong", function(e, t) {
	var n = t < 5 ? t + 1 : t;
	Zt(e + ",Power" + (n - 1), t ? function(e) {
		return e ** +n;
	} : function(e) {
		return e;
	}, function(e) {
		return 1 - (1 - e) ** n;
	}, function(e) {
		return e < .5 ? (e * 2) ** n / 2 : 1 - ((1 - e) * 2) ** n / 2;
	});
}), K.Linear.easeNone = K.none = K.Linear.easeIn, Zt("Elastic", $t("in"), $t("out"), $t()), (function(e, t) {
	var n = 1 / t, r = 2 * n, i = 2.5 * n, a = function(a) {
		return a < n ? e * a * a : a < r ? e * (a - 1.5 / t) ** 2 + .75 : a < i ? e * (a -= 2.25 / t) * a + .9375 : e * (a - 2.625 / t) ** 2 + .984375;
	};
	Zt("Bounce", function(e) {
		return 1 - a(1 - e);
	}, a);
})(7.5625, 2.75), Zt("Expo", function(e) {
	return 2 ** (10 * (e - 1)) * e + e * e * e * e * e * e * (1 - e);
}), Zt("Circ", function(e) {
	return -(f(1 - e * e) - 1);
}), Zt("Sine", function(e) {
	return e === 1 ? 1 : -p(e * u) + 1;
}), Zt("Back", en("in"), en("out"), en()), K.SteppedEase = K.steps = F.SteppedEase = { config: function(e, t) {
	e === void 0 && (e = 1);
	var n = 1 / e, r = e + +!t, i = +!!t, a = 1 - c;
	return function(e) {
		return ((r * it(0, a, e) | 0) + i) * n;
	};
} }, r.ease = K["quad.out"], ye("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e) {
	return ge += e + "," + e + "Params,";
});
var tn = function(e, t) {
	this.id = d++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : V, this.set = t ? t.getSetter : Cn;
}, nn = /*#__PURE__*/ function() {
	function e(e) {
		this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === Infinity ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, Qe(this, +e.duration, 1, 1), this.data = e.data, o && (this._ctx = o, o.data.push(this)), Vt || Ht.wake();
	}
	var t = e.prototype;
	return t.delay = function(e) {
		return e || e === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e - this._delay), this._delay = e, this) : this._delay;
	}, t.duration = function(e) {
		return arguments.length ? this.totalDuration(this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e) : this.totalDuration() && this._dur;
	}, t.totalDuration = function(e) {
		return arguments.length ? (this._dirty = 0, Qe(this, this._repeat < 0 ? e : (e - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
	}, t.totalTime = function(e, t) {
		if (Ut(), !arguments.length) return this._tTime;
		var n = this._dp;
		if (n && n.smoothChildTiming && this._ts) {
			for (Ue(this, e), !n._dp || n.parent || We(n, this); n && n.parent;) n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), n = n.parent;
			!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && e < this._tDur || this._ts < 0 && e > 0 || !this._tDur && !e) && Ge(this._dp, this, this._start - this._delay);
		}
		return (this._tTime !== e || !this._dur && !t || this._initted && Math.abs(this._zTime) === c || !this._initted && this._dur && e || !e && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = e), we(this, e, t)), this;
	}, t.time = function(e, t) {
		return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e + ze(this)) % (this._dur + this._rDelay) || (e ? this._dur : 0), t) : this._time;
	}, t.totalProgress = function(e, t) {
		return arguments.length ? this.totalTime(this.totalDuration() * e, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
	}, t.progress = function(e, t) {
		return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - e : e) + ze(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : +(this.rawTime() > 0);
	}, t.iteration = function(e, t) {
		var n = this.duration() + this._rDelay;
		return arguments.length ? this.totalTime(this._time + (e - 1) * n, t) : this._repeat ? Be(this._tTime, n) + 1 : 1;
	}, t.timeScale = function(e, t) {
		if (!arguments.length) return this._rts === -c ? 0 : this._rts;
		if (this._rts === e) return this;
		var n = this.parent && this._ts ? Ve(this.parent._time, this) : this._tTime;
		return this._rts = +e || 0, this._ts = this._ps || e === -c ? 0 : this._rts, this.totalTime(it(-Math.abs(this._delay), this.totalDuration(), n), t !== !1), He(this), Ie(this);
	}, t.paused = function(e) {
		return arguments.length ? (this._ps !== e && (this._ps = e, e ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Ut(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== c && (this._tTime -= c)))), this) : this._ps;
	}, t.startTime = function(e) {
		if (arguments.length) {
			this._start = U(e);
			var t = this.parent || this._dp;
			return t && (t._sort || !this.parent) && Ge(t, this, this._start - this._delay), this;
		}
		return this._start;
	}, t.endTime = function(e) {
		return this._start + (b(e) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
	}, t.rawTime = function(e) {
		var t = this.parent || this._dp;
		return t ? e && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Ve(t.rawTime(e), this) : this._tTime : this._tTime;
	}, t.revert = function(e) {
		e === void 0 && (e = ce);
		var t = a;
		return a = e, Ce(this) && (this.timeline && this.timeline.revert(e), this.totalTime(-.01, e.suppressEvents)), this.data !== "nested" && e.kill !== !1 && this.kill(), a = t, this;
	}, t.globalTime = function(e) {
		for (var t = this, n = arguments.length ? e : t.rawTime(); t;) n = t._start + n / (Math.abs(t._ts) || 1), t = t._dp;
		return !this.parent && this._sat ? this._sat.globalTime(e) : n;
	}, t.repeat = function(e) {
		return arguments.length ? (this._repeat = e === Infinity ? -2 : e, $e(this)) : this._repeat === -2 ? Infinity : this._repeat;
	}, t.repeatDelay = function(e) {
		if (arguments.length) {
			var t = this._time;
			return this._rDelay = e, $e(this), t ? this.time(t) : this;
		}
		return this._rDelay;
	}, t.yoyo = function(e) {
		return arguments.length ? (this._yoyo = e, this) : this._yoyo;
	}, t.seek = function(e, t) {
		return this.totalTime(tt(this, e), b(t));
	}, t.restart = function(e, t) {
		return this.play().totalTime(e ? -this._delay : 0, b(t)), this._dur || (this._zTime = -c), this;
	}, t.play = function(e, t) {
		return e != null && this.seek(e, t), this.reversed(!1).paused(!1);
	}, t.reverse = function(e, t) {
		return e != null && this.seek(e || this.totalDuration(), t), this.reversed(!0).paused(!1);
	}, t.pause = function(e, t) {
		return e != null && this.seek(e, t), this.paused(!0);
	}, t.resume = function() {
		return this.paused(!1);
	}, t.reversed = function(e) {
		return arguments.length ? (!!e !== this.reversed() && this.timeScale(-this._rts || (e ? -c : 0)), this) : this._rts < 0;
	}, t.invalidate = function() {
		return this._initted = this._act = 0, this._zTime = -c, this;
	}, t.isActive = function() {
		var e = this.parent || this._dp, t = this._start, n;
		return !!(!e || this._ts && this._initted && e.isActive() && (n = e.rawTime(!0)) >= t && n < this.endTime(!0) - c);
	}, t.eventCallback = function(e, t, n) {
		var r = this.vars;
		return arguments.length > 1 ? (t ? (r[e] = t, n && (r[e + "Params"] = n), e === "onUpdate" && (this._onUpdate = t)) : delete r[e], this) : r[e];
	}, t.then = function(e) {
		var t = this, n = t._prom;
		return new Promise(function(r) {
			var i = g(e) ? e : Ee, a = function() {
				var e = t.then;
				t.then = null, n && n(), g(i) && (i = i(t)) && (i.then || i === t) && (t.then = e), r(i), t.then = e;
			};
			t._initted && t.totalProgress() === 1 && t._ts >= 0 || !t._tTime && t._ts < 0 ? a() : t._prom = a;
		});
	}, t.kill = function() {
		Ot(this);
	}, e;
}();
W(nn.prototype, {
	_time: 0,
	_start: 0,
	_end: 0,
	_tTime: 0,
	_tDur: 0,
	_dirty: 0,
	_repeat: 0,
	_yoyo: !1,
	parent: null,
	_initted: !1,
	_rDelay: 0,
	_ts: 1,
	_dp: 0,
	ratio: 0,
	_zTime: -c,
	_prom: 0,
	_ps: !1,
	_rts: 1
});
var rn = /*#__PURE__*/ function(r) {
	t(i, r);
	function i(t, n) {
		var i;
		return t === void 0 && (t = {}), i = r.call(this, t) || this, i.labels = {}, i.smoothChildTiming = !!t.smoothChildTiming, i.autoRemoveChildren = !!t.autoRemoveChildren, i._sort = b(t.sortChildren), N && Ge(t.parent || N, e(i), n), t.reversed && i.reverse(), t.paused && i.paused(!0), t.scrollTrigger && Ke(e(i), t.scrollTrigger), i;
	}
	var o = i.prototype;
	return o.to = function(e, t, n) {
		return nt(0, arguments, this), this;
	}, o.from = function(e, t, n) {
		return nt(1, arguments, this), this;
	}, o.fromTo = function(e, t, n, r) {
		return nt(2, arguments, this), this;
	}, o.set = function(e, t, n) {
		return t.duration = 0, t.parent = this, Ae(t).repeatDelay || (t.repeat = 0), t.immediateRender = !!t.immediateRender, new vn(e, t, tt(this, n), 1), this;
	}, o.call = function(e, t, n) {
		return Ge(this, vn.delayedCall(0, e, t), n);
	}, o.staggerTo = function(e, t, n, r, i, a, o) {
		return n.duration = t, n.stagger = n.stagger || r, n.onComplete = a, n.onCompleteParams = o, n.parent = this, new vn(e, n, tt(this, i)), this;
	}, o.staggerFrom = function(e, t, n, r, i, a, o) {
		return n.runBackwards = 1, Ae(n).immediateRender = b(n.immediateRender), this.staggerTo(e, t, n, r, i, a, o);
	}, o.staggerFromTo = function(e, t, n, r, i, a, o, s) {
		return r.startAt = n, Ae(r).immediateRender = b(r.immediateRender), this.staggerTo(e, t, r, i, a, o, s);
	}, o.render = function(e, t, n) {
		var r = this._time, i = this._dirty ? this.totalDuration() : this._tDur, o = this._dur, s = e <= 0 ? 0 : U(e), l = this._zTime < 0 != e < 0 && (this._initted || !o), u, d, f, p, m, h, g, _, v, y, b, x;
		if (this !== N && s > i && e >= 0 && (s = i), s !== this._tTime || n || l) {
			if (r !== this._time && o && (s += this._time - r, e += this._time - r), u = s, v = this._start, _ = this._ts, h = !_, l && (o || (r = this._zTime), (e || !t) && (this._zTime = e)), this._repeat) {
				if (b = this._yoyo, m = o + this._rDelay, this._repeat < -1 && e < 0) return this.totalTime(m * 100 + e, t, n);
				if (u = U(s % m), s === i ? (p = this._repeat, u = o) : (y = U(s / m), p = ~~y, p && p === y && (u = o, p--), u > o && (u = o)), y = Be(this._tTime, m), !r && this._tTime && y !== p && this._tTime - y * m - this._dur <= 0 && (y = p), b && p & 1 && (u = o - u, x = 1), p !== y && !this._lock) {
					var S = b && y & 1, C = S === (b && p & 1);
					if (p < y && (S = !S), r = S ? 0 : s % o ? o : s, this._lock = 1, this.render(r || (x ? 0 : U(p * m)), t, !o)._lock = 0, this._tTime = s, !t && this.parent && Dt(this, "onRepeat"), this.vars.repeatRefresh && !x && (this.invalidate()._lock = 1, y = p), r && r !== this._time || h !== !this._ts || this.vars.onRepeat && !this.parent && !this._act || (o = this._dur, i = this._tDur, C && (this._lock = 2, r = S ? o : -1e-4, this.render(r, !0), this.vars.repeatRefresh && !x && this.invalidate()), this._lock = 0, !this._ts && !h)) return this;
				}
			}
			if (this._hasPause && !this._forcing && this._lock < 2 && (g = Ze(this, U(r), U(u)), g && (s -= u - (u = g._start))), this._tTime = s, this._time = u, this._act = !!_, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = e, r = 0), !r && s && o && !t && !y && (Dt(this, "onStart"), this._tTime !== s)) return this;
			if (u >= r && e >= 0) for (d = this._first; d;) {
				if (f = d._next, (d._act || u >= d._start) && d._ts && g !== d) {
					if (d.parent !== this) return this.render(e, t, n);
					if (d.render(d._ts > 0 ? (u - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (u - d._start) * d._ts, t, n), u !== this._time || !this._ts && !h) {
						g = 0, f && (s += this._zTime = -c);
						break;
					}
				}
				d = f;
			}
			else {
				d = this._last;
				for (var w = e < 0 ? e : u; d;) {
					if (f = d._prev, (d._act || w <= d._end) && d._ts && g !== d) {
						if (d.parent !== this) return this.render(e, t, n);
						if (d.render(d._ts > 0 ? (w - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (w - d._start) * d._ts, t, n || a && Ce(d)), u !== this._time || !this._ts && !h) {
							g = 0, f && (s += this._zTime = w ? -c : c);
							break;
						}
					}
					d = f;
				}
			}
			if (g && !t && (this.pause(), g.render(u >= r ? 0 : -c)._zTime = u >= r ? 1 : -1, this._ts)) return this._start = v, He(this), this.render(e, t, n);
			this._onUpdate && !t && Dt(this, "onUpdate", !0), (s === i && this._tTime >= this.totalDuration() || !s && r) && (v === this._start || Math.abs(_) !== Math.abs(this._ts)) && (this._lock || ((e || !o) && (s === i && this._ts > 0 || !s && this._ts < 0) && Pe(this, 1), !t && !(e < 0 && !r) && (s || r || !i) && (Dt(this, s === i && e >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(s < i && this.timeScale() > 0) && this._prom())));
		}
		return this;
	}, o.add = function(e, t) {
		var n = this;
		if (_(t) || (t = tt(this, t, e)), !(e instanceof nn)) {
			if (w(e)) return e.forEach(function(e) {
				return n.add(e, t);
			}), this;
			if (h(e)) return this.addLabel(e, t);
			if (g(e)) e = vn.delayedCall(0, e);
			else return this;
		}
		return this === e ? this : Ge(this, e, t);
	}, o.getChildren = function(e, t, n, r) {
		e === void 0 && (e = !0), t === void 0 && (t = !0), n === void 0 && (n = !0), r === void 0 && (r = -s);
		for (var i = [], a = this._first; a;) a._start >= r && (a instanceof vn ? t && i.push(a) : (n && i.push(a), e && i.push.apply(i, a.getChildren(!0, t, n)))), a = a._next;
		return i;
	}, o.getById = function(e) {
		for (var t = this.getChildren(1, 1, 1), n = t.length; n--;) if (t[n].vars.id === e) return t[n];
	}, o.remove = function(e) {
		return h(e) ? this.removeLabel(e) : g(e) ? this.killTweensOf(e) : (e.parent === this && Ne(this, e), e === this._recent && (this._recent = this._last), Fe(this));
	}, o.totalTime = function(e, t) {
		return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = U(Ht.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), r.prototype.totalTime.call(this, e, t), this._forcing = 0, this) : this._tTime;
	}, o.addLabel = function(e, t) {
		return this.labels[e] = tt(this, t), this;
	}, o.removeLabel = function(e) {
		return delete this.labels[e], this;
	}, o.addPause = function(e, t, n) {
		var r = vn.delayedCall(0, t || oe, n);
		return r.data = "isPause", this._hasPause = 1, Ge(this, r, tt(this, e));
	}, o.removePause = function(e) {
		var t = this._first;
		for (e = tt(this, e); t;) t._start === e && t.data === "isPause" && Pe(t), t = t._next;
	}, o.killTweensOf = function(e, t, n) {
		for (var r = this.getTweensOf(e, n), i = r.length; i--;) ln !== r[i] && r[i].kill(e, t);
		return this;
	}, o.getTweensOf = function(e, t) {
		for (var n = [], r = ut(e), i = this._first, a = _(t), o; i;) i instanceof vn ? xe(i._targets, r) && (a ? (!ln || i._initted && i._ts) && i.globalTime(0) <= t && i.globalTime(i.totalDuration()) > t : !t || i.isActive()) && n.push(i) : (o = i.getTweensOf(r, t)).length && n.push.apply(n, o), i = i._next;
		return n;
	}, o.tweenTo = function(e, t) {
		t ||= {};
		var n = this, r = tt(n, e), i = t, a = i.startAt, o = i.onStart, s = i.onStartParams, l = i.immediateRender, u, d = vn.to(n, W({
			ease: t.ease || "none",
			lazy: !1,
			immediateRender: !1,
			time: r,
			overwrite: "auto",
			duration: t.duration || Math.abs((r - (a && "time" in a ? a.time : n._time)) / n.timeScale()) || c,
			onStart: function() {
				if (n.pause(), !u) {
					var e = t.duration || Math.abs((r - (a && "time" in a ? a.time : n._time)) / n.timeScale());
					d._dur !== e && Qe(d, e, 0, 1).render(d._time, !0, !0), u = 1;
				}
				o && o.apply(d, s || []);
			}
		}, t));
		return l ? d.render(0) : d;
	}, o.tweenFromTo = function(e, t, n) {
		return this.tweenTo(t, W({ startAt: { time: tt(this, e) } }, n));
	}, o.recent = function() {
		return this._recent;
	}, o.nextLabel = function(e) {
		return e === void 0 && (e = this._time), Et(this, tt(this, e));
	}, o.previousLabel = function(e) {
		return e === void 0 && (e = this._time), Et(this, tt(this, e), 1);
	}, o.currentLabel = function(e) {
		return arguments.length ? this.seek(e, !0) : this.previousLabel(this._time + c);
	}, o.shiftChildren = function(e, t, n) {
		n === void 0 && (n = 0);
		var r = this._first, i = this.labels, a;
		for (e = U(e); r;) r._start >= n && (r._start += e, r._end += e), r = r._next;
		if (t) for (a in i) i[a] >= n && (i[a] += e);
		return Fe(this);
	}, o.invalidate = function(e) {
		var t = this._first;
		for (this._lock = 0; t;) t.invalidate(e), t = t._next;
		return r.prototype.invalidate.call(this, e);
	}, o.clear = function(e) {
		e === void 0 && (e = !0);
		for (var t = this._first, n; t;) n = t._next, this.remove(t), t = n;
		return this._dp && (this._time = this._tTime = this._pTime = 0), e && (this.labels = {}), Fe(this);
	}, o.totalDuration = function(e) {
		var t = 0, n = this, r = n._last, i = s, a, o, c;
		if (arguments.length) return n.timeScale((n._repeat < 0 ? n.duration() : n.totalDuration()) / (n.reversed() ? -e : e));
		if (n._dirty) {
			for (c = n.parent; r;) a = r._prev, r._dirty && r.totalDuration(), o = r._start, o > i && n._sort && r._ts && !n._lock ? (n._lock = 1, Ge(n, r, o - r._delay, 1)._lock = 0) : i = o, o < 0 && r._ts && (t -= o, (!c && !n._dp || c && c.smoothChildTiming) && (n._start += U(o / n._ts), n._time -= o, n._tTime -= o), n.shiftChildren(-o, !1, -Infinity), i = 0), r._end > t && r._ts && (t = r._end), r = a;
			Qe(n, n === N && n._time > t ? n._time : t, 1, 1), n._dirty = 0;
		}
		return n._tDur;
	}, i.updateRoot = function(e) {
		if (N._ts && (we(N, Ve(e, N)), de = Ht.frame), Ht.frame >= me) {
			me += n.autoSleep || 120;
			var t = N._first;
			if ((!t || !t._ts) && n.autoSleep && Ht._listeners.length < 2) {
				for (; t && !t._ts;) t = t._next;
				t || Ht.sleep();
			}
		}
	}, i;
}(nn);
W(rn.prototype, {
	_lock: 0,
	_hasPause: 0,
	_forcing: 0
});
var an = function(e, t, n, r, i, a, o) {
	var s = new Mn(this._pt, e, t, 0, 1, En, null, i), c = 0, l = 0, u, d, f, p, m, h, g, _;
	for (s.b = n, s.e = r, n += "", r += "", (g = ~r.indexOf("random(")) && (r = Ct(r)), a && (_ = [n, r], a(_, e, t), n = _[0], r = _[1]), d = n.match(A) || []; u = A.exec(r);) p = u[0], m = r.substring(c, u.index), f ? f = (f + 1) % 5 : m.substr(-5) === "rgba(" && (f = 1), p !== d[l++] && (h = parseFloat(d[l - 1]) || 0, s._pt = {
		_next: s._pt,
		p: m || l === 1 ? m : ",",
		s: h,
		c: p.charAt(1) === "=" ? be(h, p) - h : parseFloat(p) - h,
		m: f && f < 4 ? Math.round : 0
	}, c = A.lastIndex);
	return s.c = c < r.length ? r.substring(c, r.length) : "", s.fp = o, (j.test(r) || g) && (s.e = 0), this._pt = s, s;
}, on = function(e, t, r, i, a, o, s, c, l, u) {
	g(i) && (i = i(a || 0, e, o));
	var d = e[t], f = r === "get" ? g(d) ? l ? e[t.indexOf("set") || !g(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e[t]() : d : r, p = g(d) ? l ? xn : bn : yn, m;
	if (h(i) && (~i.indexOf("random(") && (i = Ct(i)), i.charAt(1) === "=" && (m = be(f, i) + (at(f) || 0), (m || m === 0) && (i = m))), !u || f !== i || un) return !isNaN(f * i) && i !== "" ? (m = new Mn(this._pt, e, t, +f || 0, i - (f || 0), typeof d == "boolean" ? Tn : wn, 0, p), l && (m.fp = l), s && m.modifier(s, this, e), this._pt = m) : (!d && !(t in e) && ie(t, i), an.call(this, e, t, f, i, p, c || n.stringFilter, l));
}, sn = function(e, t, n, r, i) {
	if (g(e) && (e = hn(e, i, t, n, r)), !y(e) || e.style && e.nodeType || w(e) || C(e)) return h(e) ? hn(e, i, t, n, r) : e;
	var a = {}, o;
	for (o in e) a[o] = hn(e[o], i, t, n, r);
	return a;
}, cn = function(e, t, n, r, i, a) {
	var o, s, c, l;
	if (fe[e] && (o = new fe[e]()).init(i, o.rawVars ? t[e] : sn(t[e], r, i, a, n), n, r, a) !== !1 && (n._pt = s = new Mn(n._pt, i, e, 0, 1, o.render, o, 0, o.priority), n !== kt)) for (c = n._ptLookup[n._targets.indexOf(i)], l = o._props.length; l--;) c[o._props[l]] = s;
	return o;
}, ln, un, dn = function e(t, n, o) {
	var l = t.vars, u = l.ease, d = l.startAt, f = l.immediateRender, p = l.lazy, m = l.onUpdate, h = l.runBackwards, g = l.yoyoEase, _ = l.keyframes, v = l.autoRevert, y = t._dur, x = t._startAt, S = t._targets, C = t.parent, w = C && C.data === "nested" ? C.vars.targets : S, T = t._overwrite === "auto" && !i, E = t.timeline, D = l.easeReverse || g, O, k, A, j, M, ee, P, te, ne, F, re, I, L;
	if (E && (!_ || !u) && (u = "none"), t._ease = Xt(u, r.ease), t._rEase = D && (Xt(D) || t._ease), t._from = !E && !!l.runBackwards, t._from && (t.ratio = 1), !E || _ && !l.stagger) {
		if (te = S[0] ? ve(S[0]).harness : 0, I = te && l[te.prop], O = ke(l, le), x && (x._zTime < 0 && x.progress(1), n < 0 && h && f && !v ? x.render(-1, !0) : x.revert(h && y ? z : se), x._lazy = 0), d) {
			if (Pe(t._startAt = vn.set(S, W({
				data: "isStart",
				overwrite: !1,
				parent: C,
				immediateRender: !0,
				lazy: !x && b(p),
				startAt: null,
				delay: 0,
				onUpdate: m && function() {
					return Dt(t, "onUpdate");
				},
				stagger: 0
			}, d))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (a || !f && !v) && t._startAt.revert(z), f && y && n <= 0 && o <= 0) {
				n && (t._zTime = n);
				return;
			}
		} else if (h && y && !x) {
			if (n && (f = !1), A = W({
				overwrite: !1,
				data: "isFromStart",
				lazy: f && !x && b(p),
				immediateRender: f,
				stagger: 0,
				parent: C
			}, O), I && (A[te.prop] = I), Pe(t._startAt = vn.set(S, A)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (a ? t._startAt.revert(z) : t._startAt.render(-1, !0)), t._zTime = n, !f) e(t._startAt, c, c);
			else if (!n) return;
		}
		for (t._pt = t._ptCache = 0, p = y && b(p) || p && !y, k = 0; k < S.length; k++) {
			if (M = S[k], P = M._gsap || _e(S)[k]._gsap, t._ptLookup[k] = F = {}, ue[P.id] && B.length && Se(), re = w === S ? k : w.indexOf(M), te && (ne = new te()).init(M, I || O, t, re, w) !== !1 && (t._pt = j = new Mn(t._pt, M, ne.name, 0, 1, ne.render, ne, 0, ne.priority), ne._props.forEach(function(e) {
				F[e] = j;
			}), ne.priority && (ee = 1)), !te || I) for (A in O) fe[A] && (ne = cn(A, O, t, re, M, w)) ? ne.priority && (ee = 1) : F[A] = j = on.call(t, M, A, "get", O[A], re, w, 0, l.stringFilter);
			t._op && t._op[k] && t.kill(M, t._op[k]), T && t._pt && (ln = t, N.killTweensOf(M, F, t.globalTime(n)), L = !t.parent, ln = 0), t._pt && p && (ue[P.id] = 1);
		}
		ee && jn(t), t._onInit && t._onInit(t);
	}
	t._onUpdate = m, t._initted = (!t._op || t._pt) && !L, _ && n <= 0 && E.render(s, !0, !0);
}, fn = function(e, t, n, r, i, a, o, s) {
	var c = (e._pt && e._ptCache || (e._ptCache = {}))[t], l, u, d, f;
	if (!c) for (c = e._ptCache[t] = [], d = e._ptLookup, f = e._targets.length; f--;) {
		if (l = d[f][t], l && l.d && l.d._pt) for (l = l.d._pt; l && l.p !== t && l.fp !== t;) l = l._next;
		if (!l) return un = 1, e.vars[t] = "+=0", dn(e, o), un = 0, s ? R(t + " not eligible for reset. Try splitting into individual properties") : 1;
		c.push(l);
	}
	for (f = c.length; f--;) u = c[f], l = u._pt || u, l.s = (r || r === 0) && !i ? r : l.s + (r || 0) + a * l.c, l.c = n - l.s, u.e && (u.e = H(n) + at(u.e)), u.b && (u.b = l.s + at(u.b));
}, pn = function(e, t) {
	var n = e[0] ? ve(e[0]).harness : 0, r = n && n.aliases, i, a, o, s;
	if (!r) return t;
	for (a in i = G({}, t), r) if (a in i) for (s = r[a].split(","), o = s.length; o--;) i[s[o]] = i[a];
	return i;
}, mn = function(e, t, n, r) {
	var i = t.ease || r || "power1.inOut", a, o;
	if (w(t)) o = n[e] || (n[e] = []), t.forEach(function(e, n) {
		return o.push({
			t: n / (t.length - 1) * 100,
			v: e,
			e: i
		});
	});
	else for (a in t) o = n[a] || (n[a] = []), a === "ease" || o.push({
		t: parseFloat(e),
		v: t[a],
		e: i
	});
}, hn = function(e, t, n, r, i) {
	return g(e) ? e.call(t, n, r, i) : h(e) && ~e.indexOf("random(") ? Ct(e) : e;
}, gn = ge + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", _n = {};
ye(gn + ",id,stagger,delay,duration,paused,scrollTrigger", function(e) {
	return _n[e] = 1;
});
var vn = /*#__PURE__*/ function(r) {
	t(o, r);
	function o(t, a, o, s) {
		var l;
		typeof a == "number" && (o.duration = a, a = o, o = null), l = r.call(this, s ? a : Ae(a)) || this;
		var u = l.vars, d = u.duration, f = u.delay, p = u.immediateRender, m = u.stagger, h = u.overwrite, g = u.keyframes, v = u.defaults, x = u.scrollTrigger, T = a.parent || N, E = (w(t) || C(t) ? _(t[0]) : "length" in a) ? [t] : ut(t), D, O, k, A, j, M, ee, P;
		if (l._targets = E.length ? _e(E) : R("GSAP target " + t + " not found. https://gsap.com", !n.nullTargetWarn) || [], l._ptLookup = [], l._overwrite = h, g || m || S(d) || S(f)) {
			a = l.vars;
			var te = a.easeReverse || a.yoyoEase;
			if (D = l.timeline = new rn({
				data: "nested",
				defaults: v || {},
				targets: T && T.data === "nested" ? T.vars.targets : E
			}), D.kill(), D.parent = D._dp = e(l), D._start = 0, m || S(d) || S(f)) {
				if (A = E.length, ee = m && pt(m), y(m)) for (j in m) ~gn.indexOf(j) && (P ||= {}, P[j] = m[j]);
				for (O = 0; O < A; O++) k = ke(a, _n), k.stagger = 0, te && (k.easeReverse = te), P && G(k, P), M = E[O], k.duration = +hn(d, e(l), O, M, E), k.delay = (+hn(f, e(l), O, M, E) || 0) - l._delay, !m && A === 1 && k.delay && (l._delay = f = k.delay, l._start += f, k.delay = 0), D.to(M, k, ee ? ee(O, M, E) : 0), D._ease = K.none;
				D.duration() ? d = f = 0 : l.timeline = 0;
			} else if (g) {
				Ae(W(D.vars.defaults, { ease: "none" })), D._ease = Xt(g.ease || a.ease || "none");
				var ne = 0, F, re, I;
				if (w(g)) g.forEach(function(e) {
					return D.to(E, e, ">");
				}), D.duration();
				else {
					for (j in k = {}, g) j === "ease" || j === "easeEach" || mn(j, g[j], k, g.easeEach);
					for (j in k) for (F = k[j].sort(function(e, t) {
						return e.t - t.t;
					}), ne = 0, O = 0; O < F.length; O++) re = F[O], I = {
						ease: re.e,
						duration: (re.t - (O ? F[O - 1].t : 0)) / 100 * d
					}, I[j] = re.v, D.to(E, I, ne), ne += I.duration;
					D.duration() < d && D.to({}, { duration: d - D.duration() });
				}
			}
			d || l.duration(d = D.duration());
		} else l.timeline = 0;
		return h === !0 && !i && (ln = e(l), N.killTweensOf(E), ln = 0), Ge(T, e(l), o), a.reversed && l.reverse(), a.paused && l.paused(!0), (p || !d && !g && l._start === U(T._time) && b(p) && Re(e(l)) && T.data !== "nested") && (l._tTime = -c, l.render(Math.max(0, -f) || 0)), x && Ke(e(l), x), l;
	}
	var s = o.prototype;
	return s.render = function(e, t, n) {
		var r = this._time, i = this._tDur, a = this._dur, o = e < 0, s = e > i - c && !o ? i : e < c ? 0 : e, l, u, d, f, p, m, h, g;
		if (!a) Xe(this, e, t, n);
		else if (s !== this._tTime || !e || n || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== o || this._lazy) {
			if (l = s, g = this.timeline, this._repeat) {
				if (f = a + this._rDelay, this._repeat < -1 && o) return this.totalTime(f * 100 + e, t, n);
				if (l = U(s % f), s === i ? (d = this._repeat, l = a) : (p = U(s / f), d = ~~p, d && d === p ? (l = a, d--) : l > a && (l = a)), m = this._yoyo && d & 1, m && (l = a - l), p = Be(this._tTime, f), l === r && !n && this._initted && d === p) return this._tTime = s, this;
				d !== p && this.vars.repeatRefresh && !m && !this._lock && l !== f && this._initted && (this._lock = n = 1, this.render(U(f * d), !0).invalidate()._lock = 0);
			}
			if (!this._initted) {
				if (qe(this, o ? e : l, n, t, s)) return this._tTime = 0, this;
				if (r !== this._time && !(n && this.vars.repeatRefresh && d !== p)) return this;
				if (a !== this._dur) return this.render(e, t, n);
			}
			if (this._rEase) {
				var _ = l < r;
				if (_ !== this._inv) {
					var v = _ ? r : a - r;
					this._inv = _, this._from && (this.ratio = 1 - this.ratio), this._invRatio = this.ratio, this._invTime = r, this._invRecip = v ? (_ ? -1 : 1) / v : 0, this._invScale = _ ? -this.ratio : 1 - this.ratio, this._invEase = _ ? this._rEase : this._ease;
				}
				this.ratio = h = this._invRatio + this._invScale * this._invEase((l - this._invTime) * this._invRecip);
			} else this.ratio = h = this._ease(l / a);
			if (this._from && (this.ratio = h = 1 - h), this._tTime = s, this._time = l, !this._act && this._ts && (this._act = 1, this._lazy = 0), !r && s && !t && !p && (Dt(this, "onStart"), this._tTime !== s)) return this;
			for (u = this._pt; u;) u.r(h, u.d), u = u._next;
			g && g.render(e < 0 ? e : g._dur * g._ease(l / this._dur), t, n) || this._startAt && (this._zTime = e), this._onUpdate && !t && (o && Le(this, e, t, n), Dt(this, "onUpdate")), this._repeat && d !== p && this.vars.onRepeat && !t && this.parent && Dt(this, "onRepeat"), (s === this._tDur || !s) && this._tTime === s && (o && !this._onUpdate && Le(this, e, !0, !0), (e || !a) && (s === this._tDur && this._ts > 0 || !s && this._ts < 0) && Pe(this, 1), !t && (!o || r) && (s || r || m) && (Dt(this, s === i ? "onComplete" : "onReverseComplete", !0), this._prom && !(s < i && this.timeScale() > 0) && this._prom()));
		}
		return this;
	}, s.targets = function() {
		return this._targets;
	}, s.invalidate = function(e) {
		return (!e || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(e), r.prototype.invalidate.call(this, e);
	}, s.resetTo = function(e, t, n, r, i) {
		Vt || Ht.wake(), this._ts || this.play();
		var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts), o;
		return this._initted || dn(this, a), o = this._ease(a / this._dur), fn(this, e, t, n, r, o, a, i) ? this.resetTo(e, t, n, r, 1) : (Ue(this, 0), this.parent || Me(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
	}, s.kill = function(e, t) {
		if (t === void 0 && (t = "all"), !e && (!t || t === "all")) return this._lazy = this._pt = 0, this.parent ? Ot(this) : this.scrollTrigger && this.scrollTrigger.kill(!!a), this;
		if (this.timeline) {
			var n = this.timeline.totalDuration();
			return this.timeline.killTweensOf(e, t, ln && ln.vars.overwrite !== !0)._first || Ot(this), this.parent && n !== this.timeline.totalDuration() && Qe(this, this._dur * this.timeline._tDur / n, 0, 1), this;
		}
		var r = this._targets, i = e ? ut(e) : r, o = this._ptLookup, s = this._pt, c, l, u, d, f, p, m;
		if ((!t || t === "all") && je(r, i)) return t === "all" && (this._pt = 0), Ot(this);
		for (c = this._op = this._op || [], t !== "all" && (h(t) && (f = {}, ye(t, function(e) {
			return f[e] = 1;
		}), t = f), t = pn(r, t)), m = r.length; m--;) if (~i.indexOf(r[m])) for (f in l = o[m], t === "all" ? (c[m] = t, d = l, u = {}) : (u = c[m] = c[m] || {}, d = t), d) p = l && l[f], p && ((!("kill" in p.d) || p.d.kill(f) === !0) && Ne(this, p, "_pt"), delete l[f]), u !== "all" && (u[f] = 1);
		return this._initted && !this._pt && s && Ot(this), this;
	}, o.to = function(e, t) {
		return new o(e, t, arguments[2]);
	}, o.from = function(e, t) {
		return nt(1, arguments);
	}, o.delayedCall = function(e, t, n, r) {
		return new o(t, 0, {
			immediateRender: !1,
			lazy: !1,
			overwrite: !1,
			delay: e,
			onComplete: t,
			onReverseComplete: t,
			onCompleteParams: n,
			onReverseCompleteParams: n,
			callbackScope: r
		});
	}, o.fromTo = function(e, t, n) {
		return nt(2, arguments);
	}, o.set = function(e, t) {
		return t.duration = 0, t.repeatDelay || (t.repeat = 0), new o(e, t);
	}, o.killTweensOf = function(e, t, n) {
		return N.killTweensOf(e, t, n);
	}, o;
}(nn);
W(vn.prototype, {
	_targets: [],
	_lazy: 0,
	_startAt: 0,
	_op: 0,
	_onInit: 0
}), ye("staggerTo,staggerFrom,staggerFromTo", function(e) {
	vn[e] = function() {
		var t = new rn(), n = st.call(arguments, 0);
		return n.splice(e === "staggerFromTo" ? 5 : 4, 0, 0), t[e].apply(t, n);
	};
});
var yn = function(e, t, n) {
	return e[t] = n;
}, bn = function(e, t, n) {
	return e[t](n);
}, xn = function(e, t, n, r) {
	return e[t](r.fp, n);
}, Sn = function(e, t, n) {
	return e.setAttribute(t, n);
}, Cn = function(e, t) {
	return g(e[t]) ? bn : v(e[t]) && e.setAttribute ? Sn : yn;
}, wn = function(e, t) {
	return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
}, Tn = function(e, t) {
	return t.set(t.t, t.p, !!(t.s + t.c * e), t);
}, En = function(e, t) {
	var n = t._pt, r = "";
	if (!e && t.b) r = t.b;
	else if (e === 1 && t.e) r = t.e;
	else {
		for (; n;) r = n.p + (n.m ? n.m(n.s + n.c * e) : Math.round((n.s + n.c * e) * 1e4) / 1e4) + r, n = n._next;
		r += t.c;
	}
	t.set(t.t, t.p, r, t);
}, Dn = function(e, t) {
	for (var n = t._pt; n;) n.r(e, n.d), n = n._next;
}, On = function(e, t, n, r) {
	for (var i = this._pt, a; i;) a = i._next, i.p === r && i.modifier(e, t, n), i = a;
}, kn = function(e) {
	for (var t = this._pt, n, r; t;) r = t._next, t.p === e && !t.op || t.op === e ? Ne(this, t, "_pt") : t.dep || (n = 1), t = r;
	return !n;
}, An = function(e, t, n, r) {
	r.mSet(e, t, r.m.call(r.tween, n, r.mt), r);
}, jn = function(e) {
	for (var t = e._pt, n, r, i, a; t;) {
		for (n = t._next, r = i; r && r.pr > t.pr;) r = r._next;
		(t._prev = r ? r._prev : a) ? t._prev._next = t : i = t, (t._next = r) ? r._prev = t : a = t, t = n;
	}
	e._pt = i;
}, Mn = /*#__PURE__*/ function() {
	function e(e, t, n, r, i, a, o, s, c) {
		this.t = t, this.s = r, this.c = i, this.p = n, this.r = a || wn, this.d = o || this, this.set = s || yn, this.pr = c || 0, this._next = e, e && (e._prev = this);
	}
	var t = e.prototype;
	return t.modifier = function(e, t, n) {
		this.mSet = this.mSet || this.set, this.set = An, this.m = e, this.mt = n, this.tween = t;
	}, e;
}();
ye(ge + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(e) {
	return le[e] = 1;
}), F.TweenMax = F.TweenLite = vn, F.TimelineLite = F.TimelineMax = rn, N = new rn({
	sortChildren: !1,
	defaults: r,
	autoRemoveChildren: !0,
	id: "root",
	smoothChildTiming: !0
}), n.stringFilter = Bt;
var Nn = [], Pn = {}, Fn = [], In = 0, Ln = 0, Rn = function(e) {
	return (Pn[e] || Fn).map(function(e) {
		return e();
	});
}, zn = function() {
	var e = Date.now(), t = [];
	e - In > 2 && (Rn("matchMediaInit"), Nn.forEach(function(e) {
		var n = e.queries, r = e.conditions, i, a, o, s;
		for (a in n) i = P.matchMedia(n[a]).matches, i && (o = 1), i !== r[a] && (r[a] = i, s = 1);
		s && (e.revert(), o && t.push(e));
	}), Rn("matchMediaRevert"), t.forEach(function(e) {
		return e.onMatch(e, function(t) {
			return e.add(null, t);
		});
	}), In = e, Rn("matchMedia"));
}, Bn = /*#__PURE__*/ function() {
	function e(e, t) {
		this.selector = t && dt(t), this.data = [], this._r = [], this.isReverted = !1, this.id = Ln++, e && this.add(e);
	}
	var t = e.prototype;
	return t.add = function(e, t, n) {
		g(e) && (n = t, t = e, e = g);
		var r = this, i = function() {
			var e = o, i = r.selector, a;
			return e && e !== r && e.data.push(r), n && (r.selector = dt(n)), o = r, a = t.apply(r, arguments), g(a) && r._r.push(a), o = e, r.selector = i, r.isReverted = !1, a;
		};
		return r.last = i, e === g ? i(r, function(e) {
			return r.add(null, e);
		}) : e ? r[e] = i : i;
	}, t.ignore = function(e) {
		var t = o;
		o = null, e(this), o = t;
	}, t.getTweens = function() {
		var t = [];
		return this.data.forEach(function(n) {
			return n instanceof e ? t.push.apply(t, n.getTweens()) : n instanceof vn && !(n.parent && n.parent.data === "nested") && t.push(n);
		}), t;
	}, t.clear = function() {
		this._r.length = this.data.length = 0;
	}, t.kill = function(e, t) {
		var n = this;
		if (e ? (function() {
			for (var t = n.getTweens(), r = n.data.length, i; r--;) i = n.data[r], i.data === "isFlip" && (i.revert(), i.getChildren(!0, !0, !1).forEach(function(e) {
				return t.splice(t.indexOf(e), 1);
			}));
			for (t.map(function(e) {
				return {
					g: e._dur || e._delay || e._sat && !e._sat.vars.immediateRender ? e.globalTime(0) : -Infinity,
					t: e
				};
			}).sort(function(e, t) {
				return t.g - e.g || -Infinity;
			}).forEach(function(t) {
				return t.t.revert(e);
			}), r = n.data.length; r--;) i = n.data[r], i instanceof rn ? i.data !== "nested" && (i.scrollTrigger && i.scrollTrigger.revert(), i.kill()) : !(i instanceof vn) && i.revert && i.revert(e);
			n._r.forEach(function(t) {
				return t(e, n);
			}), n.isReverted = !0;
		})() : this.data.forEach(function(e) {
			return e.kill && e.kill();
		}), this.clear(), t) for (var r = Nn.length; r--;) Nn[r].id === this.id && Nn.splice(r, 1);
	}, t.revert = function(e) {
		this.kill(e || {});
	}, e;
}(), Vn = /*#__PURE__*/ function() {
	function e(e) {
		this.contexts = [], this.scope = e, o && o.data.push(this);
	}
	var t = e.prototype;
	return t.add = function(e, t, n) {
		y(e) || (e = { matches: e });
		var r = new Bn(0, n || this.scope), i = r.conditions = {}, a, s, c;
		for (s in o && !r.selector && (r.selector = o.selector), this.contexts.push(r), t = r.add("onMatch", t), r.queries = e, e) s === "all" ? c = 1 : (a = P.matchMedia(e[s]), a && (Nn.indexOf(r) < 0 && Nn.push(r), (i[s] = a.matches) && (c = 1), a.addListener ? a.addListener(zn) : a.addEventListener("change", zn)));
		return c && t(r, function(e) {
			return r.add(null, e);
		}), this;
	}, t.revert = function(e) {
		this.kill(e || {});
	}, t.kill = function(e) {
		this.contexts.forEach(function(t) {
			return t.kill(e, !0);
		});
	}, e;
}(), Hn = {
	registerPlugin: function() {
		[...arguments].forEach(function(e) {
			return jt(e);
		});
	},
	timeline: function(e) {
		return new rn(e);
	},
	getTweensOf: function(e, t) {
		return N.getTweensOf(e, t);
	},
	getProperty: function(e, t, n, r) {
		h(e) && (e = ut(e)[0]);
		var i = ve(e || {}).get, a = n ? Ee : Te;
		return n === "native" && (n = ""), e && (t ? a((fe[t] && fe[t].get || i)(e, t, n, r)) : function(t, n, r) {
			return a((fe[t] && fe[t].get || i)(e, t, n, r));
		});
	},
	quickSetter: function(e, t, n) {
		if (e = ut(e), e.length > 1) {
			var r = e.map(function(e) {
				return Kn.quickSetter(e, t, n);
			}), i = r.length;
			return function(e) {
				for (var t = i; t--;) r[t](e);
			};
		}
		e = e[0] || {};
		var a = fe[t], o = ve(e), s = o.harness && (o.harness.aliases || {})[t] || t, c = a ? function(t) {
			var r = new a();
			kt._pt = 0, r.init(e, n ? t + n : t, kt, 0, [e]), r.render(1, r), kt._pt && Dn(1, kt);
		} : o.set(e, s);
		return a ? c : function(t) {
			return c(e, s, n ? t + n : t, o, 1);
		};
	},
	quickTo: function(e, t, n) {
		var r, i = Kn.to(e, W((r = {}, r[t] = "+=0.1", r.paused = !0, r.stagger = 0, r), n || {})), a = function(e, n, r) {
			return i.resetTo(t, e, n, r);
		};
		return a.tween = i, a;
	},
	isTweening: function(e) {
		return N.getTweensOf(e, !0).length > 0;
	},
	defaults: function(e) {
		return e && e.ease && (e.ease = Xt(e.ease, r.ease)), Oe(r, e || {});
	},
	config: function(e) {
		return Oe(n, e || {});
	},
	registerEffect: function(e) {
		var t = e.name, n = e.effect, r = e.plugins, i = e.defaults, a = e.extendTimeline;
		(r || "").split(",").forEach(function(e) {
			return e && !fe[e] && !F[e] && R(t + " effect requires " + e + " plugin.");
		}), pe[t] = function(e, t, r) {
			return n(ut(e), W(t || {}, i), r);
		}, a && (rn.prototype[t] = function(e, n, r) {
			return this.add(pe[t](e, y(n) ? n : (r = n) && {}, this), r);
		});
	},
	registerEase: function(e, t) {
		K[e] = Xt(t);
	},
	parseEase: function(e, t) {
		return arguments.length ? Xt(e, t) : K;
	},
	getById: function(e) {
		return N.getById(e);
	},
	exportRoot: function(e, t) {
		e === void 0 && (e = {});
		var n = new rn(e), r, i;
		for (n.smoothChildTiming = b(e.smoothChildTiming), N.remove(n), n._dp = 0, n._time = n._tTime = N._time, r = N._first; r;) i = r._next, (t || !(!r._dur && r instanceof vn && r.vars.onComplete === r._targets[0])) && Ge(n, r, r._start - r._delay), r = i;
		return Ge(N, n, 0), n;
	},
	context: function(e, t) {
		return e ? new Bn(e, t) : o;
	},
	matchMedia: function(e) {
		return new Vn(e);
	},
	matchMediaRefresh: function() {
		return Nn.forEach(function(e) {
			var t = e.conditions, n, r;
			for (r in t) t[r] && (t[r] = !1, n = 1);
			n && e.revert();
		}) || zn();
	},
	addEventListener: function(e, t) {
		var n = Pn[e] || (Pn[e] = []);
		~n.indexOf(t) || n.push(t);
	},
	removeEventListener: function(e, t) {
		var n = Pn[e], r = n && n.indexOf(t);
		r >= 0 && n.splice(r, 1);
	},
	utils: {
		wrap: xt,
		wrapYoyo: St,
		distribute: pt,
		random: gt,
		snap: ht,
		normalize: yt,
		getUnit: at,
		clamp: ot,
		splitColor: Ft,
		toArray: ut,
		selector: dt,
		mapRange: wt,
		pipe: _t,
		unitize: vt,
		interpolate: Tt,
		shuffle: ft
	},
	install: L,
	effects: pe,
	ticker: Ht,
	updateRoot: rn.updateRoot,
	plugins: fe,
	globalTimeline: N,
	core: {
		PropTween: Mn,
		globals: ae,
		Tween: vn,
		Timeline: rn,
		Animation: nn,
		getCache: ve,
		_removeLinkedListItem: Ne,
		reverting: function() {
			return a;
		},
		context: function(e) {
			return e && o && (o.data.push(e), e._ctx = o), o;
		},
		suppressOverwrites: function(e) {
			return i = e;
		}
	}
};
ye("to,from,fromTo,delayedCall,set,killTweensOf", function(e) {
	return Hn[e] = vn[e];
}), Ht.add(rn.updateRoot), kt = Hn.to({}, { duration: 0 });
var Un = function(e, t) {
	for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t;) n = n._next;
	return n;
}, Wn = function(e, t) {
	var n = e._targets, r, i, a;
	for (r in t) for (i = n.length; i--;) a = e._ptLookup[i][r], (a &&= a.d) && (a._pt && (a = Un(a, r)), a && a.modifier && a.modifier(t[r], e, n[i], r));
}, Gn = function(e, t) {
	return {
		name: e,
		headless: 1,
		rawVars: 1,
		init: function(e, n, r) {
			r._onInit = function(e) {
				var r, i;
				if (h(n) && (r = {}, ye(n, function(e) {
					return r[e] = 1;
				}), n = r), t) {
					for (i in r = {}, n) r[i] = t(n[i]);
					n = r;
				}
				Wn(e, n);
			};
		}
	};
}, Kn = Hn.registerPlugin({
	name: "attr",
	init: function(e, t, n, r, i) {
		var a, o, s;
		for (a in this.tween = n, t) s = e.getAttribute(a) || "", o = this.add(e, "setAttribute", (s || 0) + "", t[a], r, i, 0, 0, a), o.op = a, o.b = s, this._props.push(a);
	},
	render: function(e, t) {
		for (var n = t._pt; n;) a ? n.set(n.t, n.p, n.b, n) : n.r(e, n.d), n = n._next;
	}
}, {
	name: "endArray",
	headless: 1,
	init: function(e, t) {
		for (var n = t.length; n--;) this.add(e, n, e[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
	}
}, Gn("roundProps", mt), Gn("modifiers"), Gn("snap", ht)) || Hn;
vn.version = rn.version = Kn.version = "3.15.0", I = 1, x() && Ut(), K.Power0, K.Power1, K.Power2, K.Power3, K.Power4, K.Linear, K.Quad, K.Cubic, K.Quart, K.Quint, K.Strong, K.Elastic, K.Back, K.SteppedEase, K.Bounce, K.Sine, K.Expo, K.Circ;
//#endregion
//#region ../packet-preview-2026-09-07/node_modules/gsap/CSSPlugin.js
var qn, Jn, Yn, Xn, Zn, Qn, $n, er = function() {
	return typeof window < "u";
}, tr = {}, nr = 180 / Math.PI, rr = Math.PI / 180, ir = Math.atan2, ar = 1e8, or = /([A-Z])/g, sr = /(left|right|width|margin|padding|x)/i, cr = /[\s,\(]\S/, lr = {
	autoAlpha: "opacity,visibility",
	scale: "scaleX,scaleY",
	alpha: "opacity"
}, ur = function(e, t) {
	return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, dr = function(e, t) {
	return t.set(t.t, t.p, e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, fr = function(e, t) {
	return t.set(t.t, t.p, e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, pr = function(e, t) {
	return t.set(t.t, t.p, e === 1 ? t.e : e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, mr = function(e, t) {
	var n = t.s + t.c * e;
	t.set(t.t, t.p, ~~(n + (n < 0 ? -.5 : .5)) + t.u, t);
}, hr = function(e, t) {
	return t.set(t.t, t.p, e ? t.e : t.b, t);
}, gr = function(e, t) {
	return t.set(t.t, t.p, e === 1 ? t.e : t.b, t);
}, _r = function(e, t, n) {
	return e.style[t] = n;
}, vr = function(e, t, n) {
	return e.style.setProperty(t, n);
}, yr = function(e, t, n) {
	return e._gsap[t] = n;
}, br = function(e, t, n) {
	return e._gsap.scaleX = e._gsap.scaleY = n;
}, xr = function(e, t, n, r, i) {
	var a = e._gsap;
	a.scaleX = a.scaleY = n, a.renderTransform(i, a);
}, Sr = function(e, t, n, r, i) {
	var a = e._gsap;
	a[t] = n, a.renderTransform(i, a);
}, Cr = "transform", wr = Cr + "Origin", Tr = function e(t, n) {
	var r = this, i = this.target, a = i.style, o = i._gsap;
	if (t in tr && a) {
		if (this.tfm = this.tfm || {}, t !== "transform") t = lr[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(e) {
			return r.tfm[e] = Wr(i, e);
		}) : this.tfm[t] = o.x ? o[t] : Wr(i, t), t === wr && (this.tfm.zOrigin = o.zOrigin);
		else return lr.transform.split(",").forEach(function(t) {
			return e.call(r, t, n);
		});
		if (this.props.indexOf(Cr) >= 0) return;
		o.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(wr, n, "")), t = Cr;
	}
	(a || n) && this.props.push(t, n, a[t]);
}, Er = function(e) {
	e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, Dr = function() {
	for (var e = this.props, t = this.target, n = t.style, r = t._gsap, i = 0, a; i < e.length; i += 3) e[i + 1] ? e[i + 1] === 2 ? t[e[i]](e[i + 2]) : t[e[i]] = e[i + 2] : e[i + 2] ? n[e[i]] = e[i + 2] : n.removeProperty(e[i].substr(0, 2) === "--" ? e[i] : e[i].replace(or, "-$1").toLowerCase());
	if (this.tfm) {
		for (a in this.tfm) r[a] = this.tfm[a];
		r.svg && (r.renderTransform(), t.setAttribute("data-svg-origin", this.svgo || "")), i = $n(), (!i || !i.isStart) && !n[Cr] && (Er(n), r.zOrigin && n[wr] && (n[wr] += " " + r.zOrigin + "px", r.zOrigin = 0, r.renderTransform()), r.uncache = 1);
	}
}, Or = function(e, t) {
	var n = {
		target: e,
		props: [],
		revert: Dr,
		save: Tr
	};
	return e._gsap || Kn.core.getCache(e), t && e.style && e.nodeType && t.split(",").forEach(function(e) {
		return n.save(e);
	}), n;
}, kr, Ar = function(e, t) {
	var n = Jn.createElementNS ? Jn.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Jn.createElement(e);
	return n && n.style ? n : Jn.createElement(e);
}, jr = function e(t, n, r) {
	var i = getComputedStyle(t);
	return i[n] || i.getPropertyValue(n.replace(or, "-$1").toLowerCase()) || i.getPropertyValue(n) || !r && e(t, Nr(n) || n, 1) || "";
}, Mr = "O,Moz,ms,Ms,Webkit".split(","), Nr = function(e, t, n) {
	var r = (t || Zn).style, i = 5;
	if (e in r && !n) return e;
	for (e = e.charAt(0).toUpperCase() + e.substr(1); i-- && !(Mr[i] + e in r););
	return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? Mr[i] : "") + e;
}, Pr = function() {
	er() && window.document && (qn = window, Jn = qn.document, Yn = Jn.documentElement, Zn = Ar("div") || { style: {} }, Ar("div"), Cr = Nr(Cr), wr = Cr + "Origin", Zn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", kr = !!Nr("perspective"), $n = Kn.core.reverting, Xn = 1);
}, Fr = function(e) {
	var t = e.ownerSVGElement, n = Ar("svg", t && t.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = e.cloneNode(!0), i;
	r.style.display = "block", n.appendChild(r), Yn.appendChild(n);
	try {
		i = r.getBBox();
	} catch {}
	return n.removeChild(r), Yn.removeChild(n), i;
}, Ir = function(e, t) {
	for (var n = t.length; n--;) if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
}, Lr = function(e) {
	var t, n;
	try {
		t = e.getBBox();
	} catch {
		t = Fr(e), n = 1;
	}
	return t && (t.width || t.height) || n || (t = Fr(e)), t && !t.width && !t.x && !t.y ? {
		x: +Ir(e, [
			"x",
			"cx",
			"x1"
		]) || 0,
		y: +Ir(e, [
			"y",
			"cy",
			"y1"
		]) || 0,
		width: 0,
		height: 0
	} : t;
}, Rr = function(e) {
	return !(!e.getCTM || e.parentNode && !e.ownerSVGElement || !Lr(e));
}, zr = function(e, t) {
	if (t) {
		var n = e.style, r;
		t in tr && t !== wr && (t = Cr), n.removeProperty ? (r = t.substr(0, 2), (r === "ms" || t.substr(0, 6) === "webkit") && (t = "-" + t), n.removeProperty(r === "--" ? t : t.replace(or, "-$1").toLowerCase())) : n.removeAttribute(t);
	}
}, Br = function(e, t, n, r, i, a) {
	var o = new Mn(e._pt, t, n, 0, 1, a ? gr : hr);
	return e._pt = o, o.b = r, o.e = i, e._props.push(n), o;
}, Vr = {
	deg: 1,
	rad: 1,
	turn: 1
}, Hr = {
	grid: 1,
	flex: 1
}, Ur = function e(t, n, r, i) {
	var a = parseFloat(r) || 0, o = (r + "").trim().substr((a + "").length) || "px", s = Zn.style, c = sr.test(n), l = t.tagName.toLowerCase() === "svg", u = (l ? "client" : "offset") + (c ? "Width" : "Height"), d = 100, f = i === "px", p = i === "%", m, h, g, _;
	if (i === o || !a || Vr[i] || Vr[o]) return a;
	if (o !== "px" && !f && (a = e(t, n, r, "px")), _ = t.getCTM && Rr(t), (p || o === "%") && (tr[n] || ~n.indexOf("adius"))) return m = _ ? t.getBBox()[c ? "width" : "height"] : t[u], H(p ? a / m * d : a / 100 * m);
	if (s[c ? "width" : "height"] = d + (f ? o : i), h = i !== "rem" && ~n.indexOf("adius") || i === "em" && t.appendChild && !l ? t : t.parentNode, _ && (h = (t.ownerSVGElement || {}).parentNode), (!h || h === Jn || !h.appendChild) && (h = Jn.body), g = h._gsap, g && p && g.width && c && g.time === Ht.time && !g.uncache) return H(a / g.width * d);
	if (p && (n === "height" || n === "width")) {
		var v = t.style[n];
		t.style[n] = d + i, m = t[u], v ? t.style[n] = v : zr(t, n);
	} else (p || o === "%") && !Hr[jr(h, "display")] && (s.position = jr(t, "position")), h === t && (s.position = "static"), h.appendChild(Zn), m = Zn[u], h.removeChild(Zn), s.position = "absolute";
	return c && p && (g = ve(h), g.time = Ht.time, g.width = h[u]), H(f ? m * a / d : m && a ? d / m * a : 0);
}, Wr = function(e, t, n, r) {
	var i;
	return Xn || Pr(), t in lr && t !== "transform" && (t = lr[t], ~t.indexOf(",") && (t = t.split(",")[0])), tr[t] && t !== "transform" ? (i = ni(e, r), i = t === "transformOrigin" ? i.svg ? i.origin : ri(jr(e, wr)) + " " + i.zOrigin + "px" : i[t]) : (i = e.style[t], (!i || i === "auto" || r || ~(i + "").indexOf("calc(")) && (i = Yr[t] && Yr[t](e, t, n) || jr(e, t) || V(e, t) || +(t === "opacity"))), n && !~(i + "").trim().indexOf(" ") ? Ur(e, t, i, n) + n : i;
}, Gr = function(e, t, r, i) {
	if (!r || r === "none") {
		var a = Nr(t, e, 1), o = a && jr(e, a, 1);
		o && o !== r ? (t = a, r = o) : t === "borderColor" && (r = jr(e, "borderTopColor"));
	}
	var s = new Mn(this._pt, e.style, t, 0, 1, En), c = 0, l = 0, u, d, f, p, m, h, g, _, v, y, b, x;
	if (s.b = r, s.e = i, r += "", i += "", i.substring(0, 6) === "var(--" && (i = jr(e, i.substring(4, i.indexOf(")")))), i === "auto" && (h = e.style[t], e.style[t] = i, i = jr(e, t) || i, h ? e.style[t] = h : zr(e, t)), u = [r, i], Bt(u), r = u[0], i = u[1], f = r.match(k) || [], x = i.match(k) || [], x.length) {
		for (; d = k.exec(i);) g = d[0], v = i.substring(c, d.index), m ? m = (m + 1) % 5 : (v.substr(-5) === "rgba(" || v.substr(-5) === "hsla(") && (m = 1), g !== (h = f[l++] || "") && (p = parseFloat(h) || 0, b = h.substr((p + "").length), g.charAt(1) === "=" && (g = be(p, g) + b), _ = parseFloat(g), y = g.substr((_ + "").length), c = k.lastIndex - y.length, y || (y = y || n.units[t] || b, c === i.length && (i += y, s.e += y)), b !== y && (p = Ur(e, t, h, y) || 0), s._pt = {
			_next: s._pt,
			p: v || l === 1 ? v : ",",
			s: p,
			c: _ - p,
			m: m && m < 4 || t === "zIndex" ? Math.round : 0
		});
		s.c = c < i.length ? i.substring(c, i.length) : "";
	} else s.r = t === "display" && i === "none" ? gr : hr;
	return j.test(i) && (s.e = 0), this._pt = s, s;
}, Kr = {
	top: "0%",
	bottom: "100%",
	left: "0%",
	right: "100%",
	center: "50%"
}, qr = function(e) {
	var t = e.split(" "), n = t[0], r = t[1] || "50%";
	return (n === "top" || n === "bottom" || r === "left" || r === "right") && (e = n, n = r, r = e), t[0] = Kr[n] || n, t[1] = Kr[r] || r, t.join(" ");
}, Jr = function(e, t) {
	if (t.tween && t.tween._time === t.tween._dur) {
		var n = t.t, r = n.style, i = t.u, a = n._gsap, o, s, c;
		if (i === "all" || i === !0) r.cssText = "", s = 1;
		else for (i = i.split(","), c = i.length; --c > -1;) o = i[c], tr[o] && (s = 1, o = o === "transformOrigin" ? wr : Cr), zr(n, o);
		s && (zr(n, Cr), a && (a.svg && n.removeAttribute("transform"), r.scale = r.rotate = r.translate = "none", ni(n, 1), a.uncache = 1, Er(r)));
	}
}, Yr = { clearProps: function(e, t, n, r, i) {
	if (i.data !== "isFromStart") {
		var a = e._pt = new Mn(e._pt, t, n, 0, 0, Jr);
		return a.u = r, a.pr = -10, a.tween = i, e._props.push(n), 1;
	}
} }, Xr = [
	1,
	0,
	0,
	1,
	0,
	0
], Zr = {}, Qr = function(e) {
	return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, $r = function(e) {
	var t = jr(e, Cr);
	return Qr(t) ? Xr : t.substr(7).match(O).map(H);
}, ei = function(e, t) {
	var n = e._gsap || ve(e), r = e.style, i = $r(e), a, o, s, c;
	return n.svg && e.getAttribute("transform") ? (s = e.transform.baseVal.consolidate().matrix, i = [
		s.a,
		s.b,
		s.c,
		s.d,
		s.e,
		s.f
	], i.join(",") === "1,0,0,1,0,0" ? Xr : i) : (i === Xr && !e.offsetParent && e !== Yn && !n.svg && (s = r.display, r.display = "block", a = e.parentNode, (!a || !e.offsetParent && !e.getBoundingClientRect().width) && (c = 1, o = e.nextElementSibling, Yn.appendChild(e)), i = $r(e), s ? r.display = s : zr(e, "display"), c && (o ? a.insertBefore(e, o) : a ? a.appendChild(e) : Yn.removeChild(e))), t && i.length > 6 ? [
		i[0],
		i[1],
		i[4],
		i[5],
		i[12],
		i[13]
	] : i);
}, ti = function(e, t, n, r, i, a) {
	var o = e._gsap, s = i || ei(e, !0), c = o.xOrigin || 0, l = o.yOrigin || 0, u = o.xOffset || 0, d = o.yOffset || 0, f = s[0], p = s[1], m = s[2], h = s[3], g = s[4], _ = s[5], v = t.split(" "), y = parseFloat(v[0]) || 0, b = parseFloat(v[1]) || 0, x, S, C, w;
	n ? s !== Xr && (S = f * h - p * m) && (C = h / S * y + b * (-m / S) + (m * _ - h * g) / S, w = y * (-p / S) + f / S * b - (f * _ - p * g) / S, y = C, b = w) : (x = Lr(e), y = x.x + (~v[0].indexOf("%") ? y / 100 * x.width : y), b = x.y + (~(v[1] || v[0]).indexOf("%") ? b / 100 * x.height : b)), r || r !== !1 && o.smooth ? (g = y - c, _ = b - l, o.xOffset = u + (g * f + _ * m) - g, o.yOffset = d + (g * p + _ * h) - _) : o.xOffset = o.yOffset = 0, o.xOrigin = y, o.yOrigin = b, o.smooth = !!r, o.origin = t, o.originIsAbsolute = !!n, e.style[wr] = "0px 0px", a && (Br(a, o, "xOrigin", c, y), Br(a, o, "yOrigin", l, b), Br(a, o, "xOffset", u, o.xOffset), Br(a, o, "yOffset", d, o.yOffset)), e.setAttribute("data-svg-origin", y + " " + b);
}, ni = function(e, t) {
	var r = e._gsap || new tn(e);
	if ("x" in r && !t && !r.uncache) return r;
	var i = e.style, a = r.scaleX < 0, o = "px", s = "deg", c = getComputedStyle(e), l = jr(e, wr) || "0", u = d = f = h = g = _ = v = y = b = 0, d, f, p = m = 1, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, k, A, j, M, ee, N, P, te, ne, F, re, I, L;
	return r.svg = !!(e.getCTM && Rr(e)), c.translate && ((c.translate !== "none" || c.scale !== "none" || c.rotate !== "none") && (i[Cr] = (c.translate === "none" ? "" : "translate3d(" + (c.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") ") + (c.rotate === "none" ? "" : "rotate(" + c.rotate + ") ") + (c.scale === "none" ? "" : "scale(" + c.scale.split(" ").join(",") + ") ") + (c[Cr] === "none" ? "" : c[Cr])), i.scale = i.rotate = i.translate = "none"), C = ei(e, r.svg), r.svg && (r.uncache ? (N = e.getBBox(), l = r.xOrigin - N.x + "px " + (r.yOrigin - N.y) + "px", ee = "") : ee = !t && e.getAttribute("data-svg-origin"), ti(e, ee || l, !!ee || r.originIsAbsolute, r.smooth !== !1, C)), x = r.xOrigin || 0, S = r.yOrigin || 0, C !== Xr && (D = C[0], O = C[1], k = C[2], A = C[3], u = j = C[4], d = M = C[5], C.length === 6 ? (p = Math.sqrt(D * D + O * O), m = Math.sqrt(A * A + k * k), h = D || O ? ir(O, D) * nr : 0, v = k || A ? ir(k, A) * nr + h : 0, v && (m *= Math.abs(Math.cos(v * rr))), r.svg && (u -= x - (x * D + S * k), d -= S - (x * O + S * A))) : (L = C[6], re = C[7], te = C[8], ne = C[9], F = C[10], I = C[11], u = C[12], d = C[13], f = C[14], w = ir(L, F), g = w * nr, w && (T = Math.cos(-w), E = Math.sin(-w), ee = j * T + te * E, N = M * T + ne * E, P = L * T + F * E, te = j * -E + te * T, ne = M * -E + ne * T, F = L * -E + F * T, I = re * -E + I * T, j = ee, M = N, L = P), w = ir(-k, F), _ = w * nr, w && (T = Math.cos(-w), E = Math.sin(-w), ee = D * T - te * E, N = O * T - ne * E, P = k * T - F * E, I = A * E + I * T, D = ee, O = N, k = P), w = ir(O, D), h = w * nr, w && (T = Math.cos(w), E = Math.sin(w), ee = D * T + O * E, N = j * T + M * E, O = O * T - D * E, M = M * T - j * E, D = ee, j = N), g && Math.abs(g) + Math.abs(h) > 359.9 && (g = h = 0, _ = 180 - _), p = H(Math.sqrt(D * D + O * O + k * k)), m = H(Math.sqrt(M * M + L * L)), w = ir(j, M), v = Math.abs(w) > 2e-4 ? w * nr : 0, b = I ? 1 / (I < 0 ? -I : I) : 0), r.svg && (ee = e.getAttribute("transform"), r.forceCSS = e.setAttribute("transform", "") || !Qr(jr(e, Cr)), ee && e.setAttribute("transform", ee))), Math.abs(v) > 90 && Math.abs(v) < 270 && (a ? (p *= -1, v += h <= 0 ? 180 : -180, h += h <= 0 ? 180 : -180) : (m *= -1, v += v <= 0 ? 180 : -180)), t ||= r.uncache, r.x = u - ((r.xPercent = u && (!t && r.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-u) ? -50 : 0))) ? e.offsetWidth * r.xPercent / 100 : 0) + o, r.y = d - ((r.yPercent = d && (!t && r.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-d) ? -50 : 0))) ? e.offsetHeight * r.yPercent / 100 : 0) + o, r.z = f + o, r.scaleX = H(p), r.scaleY = H(m), r.rotation = H(h) + s, r.rotationX = H(g) + s, r.rotationY = H(_) + s, r.skewX = v + s, r.skewY = y + s, r.transformPerspective = b + o, (r.zOrigin = parseFloat(l.split(" ")[2]) || !t && r.zOrigin || 0) && (i[wr] = ri(l)), r.xOffset = r.yOffset = 0, r.force3D = n.force3D, r.renderTransform = r.svg ? ui : kr ? li : ai, r.uncache = 0, r;
}, ri = function(e) {
	return (e = e.split(" "))[0] + " " + e[1];
}, ii = function(e, t, n) {
	var r = at(t);
	return H(parseFloat(t) + parseFloat(Ur(e, "x", n + "px", r))) + r;
}, ai = function(e, t) {
	t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, li(e, t);
}, oi = "0deg", si = "0px", ci = ") ", li = function(e, t) {
	var n = t || this, r = n.xPercent, i = n.yPercent, a = n.x, o = n.y, s = n.z, c = n.rotation, l = n.rotationY, u = n.rotationX, d = n.skewX, f = n.skewY, p = n.scaleX, m = n.scaleY, h = n.transformPerspective, g = n.force3D, _ = n.target, v = n.zOrigin, y = "", b = g === "auto" && e && e !== 1 || g === !0;
	if (v && (u !== oi || l !== oi)) {
		var x = parseFloat(l) * rr, S = Math.sin(x), C = Math.cos(x), w;
		x = parseFloat(u) * rr, w = Math.cos(x), a = ii(_, a, S * w * -v), o = ii(_, o, -Math.sin(x) * -v), s = ii(_, s, C * w * -v + v);
	}
	h !== si && (y += "perspective(" + h + ci), (r || i) && (y += "translate(" + r + "%, " + i + "%) "), (b || a !== si || o !== si || s !== si) && (y += s !== si || b ? "translate3d(" + a + ", " + o + ", " + s + ") " : "translate(" + a + ", " + o + ci), c !== oi && (y += "rotate(" + c + ci), l !== oi && (y += "rotateY(" + l + ci), u !== oi && (y += "rotateX(" + u + ci), (d !== oi || f !== oi) && (y += "skew(" + d + ", " + f + ci), (p !== 1 || m !== 1) && (y += "scale(" + p + ", " + m + ci), _.style[Cr] = y || "translate(0, 0)";
}, ui = function(e, t) {
	var n = t || this, r = n.xPercent, i = n.yPercent, a = n.x, o = n.y, s = n.rotation, c = n.skewX, l = n.skewY, u = n.scaleX, d = n.scaleY, f = n.target, p = n.xOrigin, m = n.yOrigin, h = n.xOffset, g = n.yOffset, _ = n.forceCSS, v = parseFloat(a), y = parseFloat(o), b, x, S, C, w;
	s = parseFloat(s), c = parseFloat(c), l = parseFloat(l), l && (l = parseFloat(l), c += l, s += l), s || c ? (s *= rr, c *= rr, b = Math.cos(s) * u, x = Math.sin(s) * u, S = Math.sin(s - c) * -d, C = Math.cos(s - c) * d, c && (l *= rr, w = Math.tan(c - l), w = Math.sqrt(1 + w * w), S *= w, C *= w, l && (w = Math.tan(l), w = Math.sqrt(1 + w * w), b *= w, x *= w)), b = H(b), x = H(x), S = H(S), C = H(C)) : (b = u, C = d, x = S = 0), (v && !~(a + "").indexOf("px") || y && !~(o + "").indexOf("px")) && (v = Ur(f, "x", a, "px"), y = Ur(f, "y", o, "px")), (p || m || h || g) && (v = H(v + p - (p * b + m * S) + h), y = H(y + m - (p * x + m * C) + g)), (r || i) && (w = f.getBBox(), v = H(v + r / 100 * w.width), y = H(y + i / 100 * w.height)), w = "matrix(" + b + "," + x + "," + S + "," + C + "," + v + "," + y + ")", f.setAttribute("transform", w), _ && (f.style[Cr] = w);
}, di = function(e, t, n, r, i) {
	var a = 360, o = h(i), s = parseFloat(i) * (o && ~i.indexOf("rad") ? nr : 1) - r, c = r + s + "deg", l, u;
	return o && (l = i.split("_")[1], l === "short" && (s %= a, s !== s % (a / 2) && (s += s < 0 ? a : -a)), l === "cw" && s < 0 ? s = (s + a * ar) % a - ~~(s / a) * a : l === "ccw" && s > 0 && (s = (s - a * ar) % a - ~~(s / a) * a)), e._pt = u = new Mn(e._pt, t, n, r, s, dr), u.e = c, u.u = "deg", e._props.push(n), u;
}, fi = function(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}, pi = function(e, t, n) {
	var r = fi({}, n._gsap), i = "perspective,force3D,transformOrigin,svgOrigin", a = n.style, o, s, c, l, u, d, f, p;
	for (s in r.svg ? (c = n.getAttribute("transform"), n.setAttribute("transform", ""), a[Cr] = t, o = ni(n, 1), zr(n, Cr), n.setAttribute("transform", c)) : (c = getComputedStyle(n)[Cr], a[Cr] = t, o = ni(n, 1), a[Cr] = c), tr) c = r[s], l = o[s], c !== l && i.indexOf(s) < 0 && (f = at(c), p = at(l), u = f === p ? parseFloat(c) : Ur(n, s, c, p), d = parseFloat(l), e._pt = new Mn(e._pt, o, s, u, d - u, ur), e._pt.u = p || 0, e._props.push(s));
	fi(o, r);
};
ye("padding,margin,Width,Radius", function(e, t) {
	var n = "Top", r = "Right", i = "Bottom", a = "Left", o = (t < 3 ? [
		n,
		r,
		i,
		a
	] : [
		n + a,
		n + r,
		i + r,
		i + a
	]).map(function(n) {
		return t < 2 ? e + n : "border" + n + e;
	});
	Yr[t > 1 ? "border" + e : e] = function(e, t, n, r, i) {
		var a, s;
		if (arguments.length < 4) return a = o.map(function(t) {
			return Wr(e, t, n);
		}), s = a.join(" "), s.split(a[0]).length === 5 ? a[0] : s;
		a = (r + "").split(" "), s = {}, o.forEach(function(e, t) {
			return s[e] = a[t] = a[t] || a[(t - 1) / 2 | 0];
		}), e.init(t, s, i);
	};
});
var mi = {
	name: "css",
	register: Pr,
	targetTest: function(e) {
		return e.style && e.nodeType;
	},
	init: function(e, t, r, i, a) {
		var o = this._props, s = e.style, c = r.vars.startAt, l, u, d, f, p, m, g, _, v, y, b, x, S, C, w, T, E;
		for (g in Xn || Pr(), this.styles = this.styles || Or(e), T = this.styles.props, this.tween = r, t) if (g !== "autoRound" && (u = t[g], !(fe[g] && cn(g, t, r, i, e, a)))) {
			if (p = typeof u, m = Yr[g], p === "function" && (u = u.call(r, i, e, a), p = typeof u), p === "string" && ~u.indexOf("random(") && (u = Ct(u)), m) m(this, e, g, u, r) && (w = 1);
			else if (g.substr(0, 2) === "--") l = (getComputedStyle(e).getPropertyValue(g) + "").trim(), u += "", Rt.lastIndex = 0, Rt.test(l) || (_ = at(l), v = at(u), v ? _ !== v && (l = Ur(e, g, l, v) + v) : _ && (u += _)), this.add(s, "setProperty", l, u, i, a, 0, 0, g), o.push(g), T.push(g, 0, s[g]);
			else if (p !== "undefined") {
				if (c && g in c ? (l = typeof c[g] == "function" ? c[g].call(r, i, e, a) : c[g], h(l) && ~l.indexOf("random(") && (l = Ct(l)), at(l + "") || l === "auto" || (l += n.units[g] || at(Wr(e, g)) || ""), (l + "").charAt(1) === "=" && (l = Wr(e, g))) : l = Wr(e, g), f = parseFloat(l), y = p === "string" && u.charAt(1) === "=" && u.substr(0, 2), y && (u = u.substr(2)), d = parseFloat(u), g in lr && (g === "autoAlpha" && (f === 1 && Wr(e, "visibility") === "hidden" && d && (f = 0), T.push("visibility", 0, s.visibility), Br(this, s, "visibility", f ? "inherit" : "hidden", d ? "inherit" : "hidden", !d)), g !== "scale" && g !== "transform" && (g = lr[g], ~g.indexOf(",") && (g = g.split(",")[0]))), b = g in tr, b) {
					if (this.styles.save(g), E = u, p === "string" && u.substring(0, 6) === "var(--") {
						if (u = jr(e, u.substring(4, u.indexOf(")"))), u.substring(0, 5) === "calc(") {
							var D = e.style.perspective;
							e.style.perspective = u, u = jr(e, "perspective"), D ? e.style.perspective = D : zr(e, "perspective");
						}
						d = parseFloat(u);
					}
					if (x || (S = e._gsap, S.renderTransform && !t.parseTransform || ni(e, t.parseTransform), C = t.smoothOrigin !== !1 && S.smooth, x = this._pt = new Mn(this._pt, s, Cr, 0, 1, S.renderTransform, S, 0, -1), x.dep = 1), g === "scale") this._pt = new Mn(this._pt, S, "scaleY", S.scaleY, (y ? be(S.scaleY, y + d) : d) - S.scaleY || 0, ur), this._pt.u = 0, o.push("scaleY", g), g += "X";
					else if (g === "transformOrigin") {
						T.push(wr, 0, s[wr]), u = qr(u), S.svg ? ti(e, u, 0, C, 0, this) : (v = parseFloat(u.split(" ")[2]) || 0, v !== S.zOrigin && Br(this, S, "zOrigin", S.zOrigin, v), Br(this, s, g, ri(l), ri(u)));
						continue;
					} else if (g === "svgOrigin") {
						ti(e, u, 1, C, 0, this);
						continue;
					} else if (g in Zr) {
						di(this, S, g, f, y ? be(f, y + u) : u);
						continue;
					} else if (g === "smoothOrigin") {
						Br(this, S, "smooth", S.smooth, u);
						continue;
					} else if (g === "force3D") {
						S[g] = u;
						continue;
					} else if (g === "transform") {
						pi(this, u, e);
						continue;
					}
				} else g in s || (g = Nr(g) || g);
				if (b || (d || d === 0) && (f || f === 0) && !cr.test(u) && g in s) _ = (l + "").substr((f + "").length), d ||= 0, v = at(u) || (g in n.units ? n.units[g] : _), _ !== v && (f = Ur(e, g, l, v)), this._pt = new Mn(this._pt, b ? S : s, g, f, (y ? be(f, y + d) : d) - f, !b && (v === "px" || g === "zIndex") && t.autoRound !== !1 ? mr : ur), this._pt.u = v || 0, b && E !== u ? (this._pt.b = l, this._pt.e = E, this._pt.r = pr) : _ !== v && v !== "%" && (this._pt.b = l, this._pt.r = fr);
				else if (g in s) Gr.call(this, e, g, l, y ? y + u : u);
				else if (g in e) this.add(e, g, l || e[g], y ? y + u : u, i, a);
				else if (g !== "parseTransform") {
					ie(g, u);
					continue;
				}
				b || (g in s ? T.push(g, 0, s[g]) : typeof e[g] == "function" ? T.push(g, 2, e[g]()) : T.push(g, 1, l || e[g])), o.push(g);
			}
		}
		w && jn(this);
	},
	render: function(e, t) {
		if (t.tween._time || !$n()) for (var n = t._pt; n;) n.r(e, n.d), n = n._next;
		else t.styles.revert();
	},
	get: Wr,
	aliases: lr,
	getSetter: function(e, t, n) {
		var r = lr[t];
		return r && r.indexOf(",") < 0 && (t = r), t in tr && t !== wr && (e._gsap.x || Wr(e, "x")) ? n && Qn === n ? t === "scale" ? br : yr : (Qn = n || {}) && (t === "scale" ? xr : Sr) : e.style && !v(e.style[t]) ? _r : ~t.indexOf("-") ? vr : Cn(e, t);
	},
	core: {
		_removeProperty: zr,
		_getMatrix: ei
	}
};
Kn.utils.checkPrefix = Nr, Kn.core.getStyleSaver = Or, (function(e, t, r, i) {
	var a = ye(e + "," + t + "," + r, function(e) {
		tr[e] = 1;
	});
	ye(t, function(e) {
		n.units[e] = "deg", Zr[e] = 1;
	}), lr[a[13]] = e + "," + t, ye(i, function(e) {
		var t = e.split(":");
		lr[t[1]] = a[t[0]];
	});
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY"), ye("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e) {
	n.units[e] = "px";
}), Kn.registerPlugin(mi);
//#endregion
//#region ../packet-preview-2026-09-07/node_modules/gsap/index.js
var hi = Kn.registerPlugin(mi) || Kn;
hi.core.Tween;
//#endregion
//#region ../packet-preview-2026-09-07/node_modules/gsap/Observer.js
function gi(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
	}
}
function _i(e, t, n) {
	return t && gi(e.prototype, t), n && gi(e, n), e;
}
var vi, yi, bi, xi, Si, Ci, wi, Ti, Ei, Di, Oi, ki, Ai, ji = function() {
	return vi || typeof window < "u" && (vi = window.gsap) && vi.registerPlugin && vi;
}, Mi = 1, Ni = [], q = [], Pi = [], Fi = Date.now, Ii = function(e, t) {
	return t;
}, Li = function() {
	var e = Ei.core, t = e.bridge || {}, n = e._scrollers, r = e._proxies;
	n.push.apply(n, q), r.push.apply(r, Pi), q = n, Pi = r, Ii = function(e, n) {
		return t[e](n);
	};
}, Ri = function(e, t) {
	return ~Pi.indexOf(e) && Pi[Pi.indexOf(e) + 1][t];
}, zi = function(e) {
	return !!~Di.indexOf(e);
}, Bi = function(e, t, n, r, i) {
	return e.addEventListener(t, n, {
		passive: r !== !1,
		capture: !!i
	});
}, Vi = function(e, t, n, r) {
	return e.removeEventListener(t, n, !!r);
}, Hi = "scrollLeft", Ui = "scrollTop", Wi = function() {
	return Oi && Oi.isPressed || q.cache++;
}, Gi = function(e, t) {
	var n = function n(r) {
		if (r || r === 0) {
			Mi && (bi.history.scrollRestoration = "manual");
			var i = Oi && Oi.isPressed;
			r = n.v = Math.round(r) || (Oi && Oi.iOS ? 1 : 0), e(r), n.cacheID = q.cache, i && Ii("ss", r);
		} else (t || q.cache !== n.cacheID || Ii("ref")) && (n.cacheID = q.cache, n.v = e());
		return n.v + n.offset;
	};
	return n.offset = 0, e && n;
}, Ki = {
	s: Hi,
	p: "left",
	p2: "Left",
	os: "right",
	os2: "Right",
	d: "width",
	d2: "Width",
	a: "x",
	sc: Gi(function(e) {
		return arguments.length ? bi.scrollTo(e, qi.sc()) : bi.pageXOffset || xi[Hi] || Si[Hi] || Ci[Hi] || 0;
	})
}, qi = {
	s: Ui,
	p: "top",
	p2: "Top",
	os: "bottom",
	os2: "Bottom",
	d: "height",
	d2: "Height",
	a: "y",
	op: Ki,
	sc: Gi(function(e) {
		return arguments.length ? bi.scrollTo(Ki.sc(), e) : bi.pageYOffset || xi[Ui] || Si[Ui] || Ci[Ui] || 0;
	})
}, Ji = function(e, t) {
	return (t && t._ctx && t._ctx.selector || vi.utils.toArray)(e)[0] || (typeof e == "string" && vi.config().nullTargetWarn !== !1 ? console.warn("Element not found:", e) : null);
}, Yi = function(e, t) {
	for (var n = t.length; n--;) if (t[n] === e || t[n].contains(e)) return !0;
	return !1;
}, Xi = function(e, t) {
	var n = t.s, r = t.sc;
	zi(e) && (e = xi.scrollingElement || Si);
	var i = q.indexOf(e), a = r === qi.sc ? 1 : 2;
	!~i && (i = q.push(e) - 1), q[i + a] || Bi(e, "scroll", Wi);
	var o = q[i + a], s = o || (q[i + a] = Gi(Ri(e, n), !0) || (zi(e) ? r : Gi(function(t) {
		return arguments.length ? e[n] = t : e[n];
	})));
	return s.target = e, o || (s.smooth = vi.getProperty(e, "scrollBehavior") === "smooth"), s;
}, Zi = function(e, t, n) {
	var r = e, i = e, a = Fi(), o = a, s = t || 50, c = Math.max(500, s * 3), l = function(e, t) {
		var c = Fi();
		t || c - a > s ? (i = r, r = e, o = a, a = c) : n ? r += e : r = i + (e - i) / (c - o) * (a - o);
	};
	return {
		update: l,
		reset: function() {
			i = r = n ? 0 : r, o = a = 0;
		},
		getVelocity: function(e) {
			var t = o, s = i, u = Fi();
			return (e || e === 0) && e !== r && l(e), a === o || u - o > c ? 0 : (r + (n ? s : -s)) / ((n ? u : a) - t) * 1e3;
		}
	};
}, Qi = function(e, t) {
	return t && !e._gsapAllow && e.cancelable !== !1 && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
}, $i = function(e) {
	var t = Math.max.apply(Math, e), n = Math.min.apply(Math, e);
	return Math.abs(t) >= Math.abs(n) ? t : n;
}, ea = function() {
	Ei = vi.core.globals().ScrollTrigger, Ei && Ei.core && Li();
}, ta = function(e) {
	return vi = e || ji(), !yi && vi && typeof document < "u" && document.body && (bi = window, xi = document, Si = xi.documentElement, Ci = xi.body, Di = [
		bi,
		xi,
		Si,
		Ci
	], vi.utils.clamp, Ai = vi.core.context || function() {}, Ti = "onpointerenter" in Ci ? "pointer" : "mouse", wi = na.isTouch = bi.matchMedia && bi.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in bi || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, ki = na.eventTypes = ("ontouchstart" in Si ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in Si ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
		return Mi = 0;
	}, 500), yi = 1), Ei || ea(), yi;
};
Ki.op = qi, q.cache = 0;
var na = /*#__PURE__*/ function() {
	function e(e) {
		this.init(e);
	}
	var t = e.prototype;
	return t.init = function(e) {
		yi || ta(vi) || console.warn("Please gsap.registerPlugin(Observer)"), Ei || ea();
		var t = e.tolerance, n = e.dragMinimum, r = e.type, i = e.target, a = e.lineHeight, o = e.debounce, s = e.preventDefault, c = e.onStop, l = e.onStopDelay, u = e.ignore, d = e.wheelSpeed, f = e.event, p = e.onDragStart, m = e.onDragEnd, h = e.onDrag, g = e.onPress, _ = e.onRelease, v = e.onRight, y = e.onLeft, b = e.onUp, x = e.onDown, S = e.onChangeX, C = e.onChangeY, w = e.onChange, T = e.onToggleX, E = e.onToggleY, D = e.onHover, O = e.onHoverEnd, k = e.onMove, A = e.ignoreCheck, j = e.isNormalizer, M = e.onGestureStart, ee = e.onGestureEnd, N = e.onWheel, P = e.onEnable, te = e.onDisable, ne = e.onClick, F = e.scrollSpeed, re = e.capture, I = e.allowClicks, L = e.lockAxis, ie = e.onLockAxis;
		this.target = i = Ji(i) || Si, this.vars = e, u &&= vi.utils.toArray(u), t ||= 1e-9, n ||= 0, d ||= 1, F ||= 1, r ||= "wheel,touch,pointer", o = o !== !1, a ||= parseFloat(bi.getComputedStyle(Ci).lineHeight) || 22;
		var R, ae, oe, se, z, ce, le, B = this, ue = 0, de = 0, fe = e.passive || !s && e.passive !== !1, pe = Xi(i, Ki), me = Xi(i, qi), he = pe(), ge = me(), _e = ~r.indexOf("touch") && !~r.indexOf("pointer") && ki[0] === "pointerdown", ve = zi(i), V = i.ownerDocument || xi, ye = [
			0,
			0,
			0
		], H = [
			0,
			0,
			0
		], U = 0, be = function() {
			return U = Fi();
		}, xe = function(e, t) {
			return (B.event = e) && u && Yi(e.target, u) || t && _e && e.pointerType !== "touch" || A && A(e, t);
		}, Se = function() {
			B._vx.reset(), B._vy.reset(), ae.pause(), c && c(B);
		}, Ce = function() {
			var e = B.deltaX = $i(ye), n = B.deltaY = $i(H), r = Math.abs(e) >= t, i = Math.abs(n) >= t;
			w && (r || i) && w(B, e, n, ye, H), r && (v && B.deltaX > 0 && v(B), y && B.deltaX < 0 && y(B), S && S(B), T && B.deltaX < 0 != ue < 0 && T(B), ue = B.deltaX, ye[0] = ye[1] = ye[2] = 0), i && (x && B.deltaY > 0 && x(B), b && B.deltaY < 0 && b(B), C && C(B), E && B.deltaY < 0 != de < 0 && E(B), de = B.deltaY, H[0] = H[1] = H[2] = 0), (se || oe) && (k && k(B), oe &&= (p && oe === 1 && p(B), h && h(B), 0), se = !1), ce && !(ce = !1) && ie && ie(B), z &&= (N(B), !1), R = 0;
		}, we = function(e, t, n) {
			ye[n] += e, H[n] += t, B._vx.update(e), B._vy.update(t), o ? R ||= requestAnimationFrame(Ce) : Ce();
		}, Te = function(e, t) {
			L && !le && (B.axis = le = Math.abs(e) > Math.abs(t) ? "x" : "y", ce = !0), le !== "y" && (ye[2] += e, B._vx.update(e, !0)), le !== "x" && (H[2] += t, B._vy.update(t, !0)), o ? R ||= requestAnimationFrame(Ce) : Ce();
		}, Ee = function(e) {
			if (!xe(e, 1)) {
				e = Qi(e, s);
				var t = e.clientX, r = e.clientY, i = t - B.x, a = r - B.y, o = B.isDragging;
				B.x = t, B.y = r, (o || (i || a) && (Math.abs(B.startX - t) >= n || Math.abs(B.startY - r) >= n)) && (oe ||= o ? 2 : 1, o || (B.isDragging = !0), Te(i, a));
			}
		}, W = B.onPress = function(e) {
			xe(e, 1) || e && e.button || (B.axis = le = null, ae.pause(), B.isPressed = !0, e = Qi(e), ue = de = 0, B.startX = B.x = e.clientX, B.startY = B.y = e.clientY, B._vx.reset(), B._vy.reset(), Bi(j ? i : V, ki[1], Ee, fe, !0), B.deltaX = B.deltaY = 0, g && g(B));
		}, De = B.onRelease = function(e) {
			if (!xe(e, 1)) {
				Vi(j ? i : V, ki[1], Ee, !0);
				var t = !isNaN(B.y - B.startY), n = B.isDragging, r = n && (Math.abs(B.x - B.startX) > 3 || Math.abs(B.y - B.startY) > 3), a = Qi(e);
				!r && t && (B._vx.reset(), B._vy.reset(), s && I && vi.delayedCall(.08, function() {
					if (Fi() - U > 300 && !e.defaultPrevented) {
						if (e.target.click) e.target.click();
						else if (V.createEvent) {
							var t = V.createEvent("MouseEvents");
							t.initMouseEvent("click", !0, !0, bi, 1, a.screenX, a.screenY, a.clientX, a.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t);
						}
					}
				})), B.isDragging = B.isGesturing = B.isPressed = !1, c && n && !j && ae.restart(!0), oe && Ce(), m && n && m(B), _ && _(B, r);
			}
		}, G = function(e) {
			return e.touches && e.touches.length > 1 && (B.isGesturing = !0) && M(e, B.isDragging);
		}, Oe = function() {
			return (B.isGesturing = !1) || ee(B);
		}, ke = function(e) {
			if (!xe(e)) {
				var t = pe(), n = me();
				we((t - he) * F, (n - ge) * F, 1), he = t, ge = n, c && ae.restart(!0);
			}
		}, Ae = function(e) {
			if (!xe(e)) {
				e = Qi(e, s), N && (z = !0);
				var t = (e.deltaMode === 1 ? a : e.deltaMode === 2 ? bi.innerHeight : 1) * d;
				we(e.deltaX * t, e.deltaY * t, 0), c && !j && ae.restart(!0);
			}
		}, je = function(e) {
			if (!xe(e)) {
				var t = e.clientX, n = e.clientY, r = t - B.x, i = n - B.y;
				B.x = t, B.y = n, se = !0, c && ae.restart(!0), (r || i) && Te(r, i);
			}
		}, Me = function(e) {
			B.event = e, D(B);
		}, Ne = function(e) {
			B.event = e, O(B);
		}, Pe = function(e) {
			return xe(e) || Qi(e, s) && ne(B);
		};
		ae = B._dc = vi.delayedCall(l || .25, Se).pause(), B.deltaX = B.deltaY = 0, B._vx = Zi(0, 50, !0), B._vy = Zi(0, 50, !0), B.scrollX = pe, B.scrollY = me, B.isDragging = B.isGesturing = B.isPressed = !1, Ai(this), B.enable = function(e) {
			return B.isEnabled || (Bi(ve ? V : i, "scroll", Wi), r.indexOf("scroll") >= 0 && Bi(ve ? V : i, "scroll", ke, fe, re), r.indexOf("wheel") >= 0 && Bi(i, "wheel", Ae, fe, re), (r.indexOf("touch") >= 0 && wi || r.indexOf("pointer") >= 0) && (Bi(i, ki[0], W, fe, re), Bi(V, ki[2], De), Bi(V, ki[3], De), I && Bi(i, "click", be, !0, !0), ne && Bi(i, "click", Pe), M && Bi(V, "gesturestart", G), ee && Bi(V, "gestureend", Oe), D && Bi(i, Ti + "enter", Me), O && Bi(i, Ti + "leave", Ne), k && Bi(i, Ti + "move", je)), B.isEnabled = !0, B.isDragging = B.isGesturing = B.isPressed = se = oe = !1, B._vx.reset(), B._vy.reset(), he = pe(), ge = me(), e && e.type && W(e), P && P(B)), B;
		}, B.disable = function() {
			B.isEnabled && (Ni.filter(function(e) {
				return e !== B && zi(e.target);
			}).length || Vi(ve ? V : i, "scroll", Wi), B.isPressed && (B._vx.reset(), B._vy.reset(), Vi(j ? i : V, ki[1], Ee, !0)), Vi(ve ? V : i, "scroll", ke, re), Vi(i, "wheel", Ae, re), Vi(i, ki[0], W, re), Vi(V, ki[2], De), Vi(V, ki[3], De), Vi(i, "click", be, !0), Vi(i, "click", Pe), Vi(V, "gesturestart", G), Vi(V, "gestureend", Oe), Vi(i, Ti + "enter", Me), Vi(i, Ti + "leave", Ne), Vi(i, Ti + "move", je), B.isEnabled = B.isPressed = B.isDragging = !1, te && te(B));
		}, B.kill = B.revert = function() {
			B.disable();
			var e = Ni.indexOf(B);
			e >= 0 && Ni.splice(e, 1), Oi === B && (Oi = 0);
		}, Ni.push(B), j && zi(i) && (Oi = B), B.enable(f);
	}, _i(e, [{
		key: "velocityX",
		get: function() {
			return this._vx.getVelocity();
		}
	}, {
		key: "velocityY",
		get: function() {
			return this._vy.getVelocity();
		}
	}]), e;
}();
na.version = "3.15.0", na.create = function(e) {
	return new na(e);
}, na.register = ta, na.getAll = function() {
	return Ni.slice();
}, na.getById = function(e) {
	return Ni.filter(function(t) {
		return t.vars.id === e;
	})[0];
}, ji() && vi.registerPlugin(na);
//#endregion
//#region ../packet-preview-2026-09-07/node_modules/gsap/ScrollTrigger.js
var J, ra, Y, X, ia, Z, aa, oa, sa, ca, la, ua, da, fa, pa, ma, ha, ga, _a, va, ya, ba, xa, Sa, Ca, wa, Ta, Ea, Da, Oa, ka, Aa, ja, Ma, Na = 1, Pa = Date.now, Fa = Pa(), Ia = 0, La = 0, Ra = function(e, t, n) {
	var r = eo(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
	return n["_" + t + "Clamp"] = r, r ? e.substr(6, e.length - 7) : e;
}, za = function(e, t) {
	return t && (!eo(e) || e.substr(0, 6) !== "clamp(") ? "clamp(" + e + ")" : e;
}, Ba = function e() {
	return La && requestAnimationFrame(e);
}, Va = function() {
	return fa = 1;
}, Ha = function() {
	return fa = 0;
}, Ua = function(e) {
	return e;
}, Wa = function(e) {
	return Math.round(e * 1e5) / 1e5 || 0;
}, Ga = function() {
	return typeof window < "u";
}, Ka = function() {
	return J || Ga() && (J = window.gsap) && J.registerPlugin && J;
}, qa = function(e) {
	return !!~aa.indexOf(e);
}, Ja = function(e) {
	return (e === "Height" ? ka : Y["inner" + e]) || ia["client" + e] || Z["client" + e];
}, Ya = function(e) {
	return Ri(e, "getBoundingClientRect") || (qa(e) ? function() {
		return Ss.width = Y.innerWidth, Ss.height = ka, Ss;
	} : function() {
		return Eo(e);
	});
}, Xa = function(e, t, n) {
	var r = n.d, i = n.d2, a = n.a;
	return (a = Ri(e, "getBoundingClientRect")) ? function() {
		return a()[r];
	} : function() {
		return (t ? Ja(i) : e["client" + i]) || 0;
	};
}, Za = function(e, t) {
	return !t || ~Pi.indexOf(e) ? Ya(e) : function() {
		return Ss;
	};
}, Qa = function(e, t) {
	var n = t.s, r = t.d2, i = t.d, a = t.a;
	return Math.max(0, (n = "scroll" + r) && (a = Ri(e, n)) ? a() - Ya(e)()[i] : qa(e) ? (ia[n] || Z[n]) - Ja(r) : e[n] - e["offset" + r]);
}, $a = function(e, t) {
	for (var n = 0; n < _a.length; n += 3) (!t || ~t.indexOf(_a[n + 1])) && e(_a[n], _a[n + 1], _a[n + 2]);
}, eo = function(e) {
	return typeof e == "string";
}, to = function(e) {
	return typeof e == "function";
}, no = function(e) {
	return typeof e == "number";
}, ro = function(e) {
	return typeof e == "object";
}, io = function(e, t, n) {
	return e && e.progress(+!t) && n && e.pause();
}, ao = function(e, t, n) {
	if (e.enabled) {
		var r = e._ctx ? e._ctx.add(function() {
			return t(e, n);
		}) : t(e, n);
		r && r.totalTime && (e.callbackAnimation = r);
	}
}, oo = Math.abs, so = "left", co = "top", lo = "right", uo = "bottom", fo = "width", po = "height", mo = "Right", ho = "Left", go = "Top", _o = "Bottom", vo = "padding", yo = "margin", bo = "Width", xo = "Height", So = "px", Co = function(e) {
	return Y.getComputedStyle(e.nodeType === Node.DOCUMENT_NODE ? e.scrollingElement : e);
}, wo = function(e) {
	var t = Co(e).position;
	e.style.position = t === "absolute" || t === "fixed" ? t : "relative";
}, To = function(e, t) {
	for (var n in t) n in e || (e[n] = t[n]);
	return e;
}, Eo = function(e, t) {
	var n = t && Co(e)[pa] !== "matrix(1, 0, 0, 1, 0, 0)" && J.to(e, {
		x: 0,
		y: 0,
		xPercent: 0,
		yPercent: 0,
		rotation: 0,
		rotationX: 0,
		rotationY: 0,
		scale: 1,
		skewX: 0,
		skewY: 0
	}).progress(1), r = e.getBoundingClientRect ? e.getBoundingClientRect() : e.scrollingElement.getBoundingClientRect();
	return n && n.progress(0).kill(), r;
}, Do = function(e, t) {
	var n = t.d2;
	return e["offset" + n] || e["client" + n] || 0;
}, Oo = function(e) {
	var t = [], n = e.labels, r = e.duration(), i;
	for (i in n) t.push(n[i] / r);
	return t;
}, ko = function(e) {
	return function(t) {
		return J.utils.snap(Oo(e), t);
	};
}, Ao = function(e) {
	var t = J.utils.snap(e), n = Array.isArray(e) && e.slice(0).sort(function(e, t) {
		return e - t;
	});
	return n ? function(e, r, i) {
		i === void 0 && (i = .001);
		var a;
		if (!r) return t(e);
		if (r > 0) {
			for (e -= i, a = 0; a < n.length; a++) if (n[a] >= e) return n[a];
			return n[a - 1];
		}
		for (a = n.length, e += i; a--;) if (n[a] <= e) return n[a];
		return n[0];
	} : function(n, r, i) {
		i === void 0 && (i = .001);
		var a = t(n);
		return !r || Math.abs(a - n) < i || a - n < 0 == r < 0 ? a : t(r < 0 ? n - e : n + e);
	};
}, jo = function(e) {
	return function(t, n) {
		return Ao(Oo(e))(t, n.direction);
	};
}, Mo = function(e, t, n, r) {
	return n.split(",").forEach(function(n) {
		return e(t, n, r);
	});
}, No = function(e, t, n, r, i) {
	return e.addEventListener(t, n, {
		passive: !r,
		capture: !!i
	});
}, Po = function(e, t, n, r) {
	return e.removeEventListener(t, n, !!r);
}, Fo = function(e, t, n) {
	n &&= n.wheelHandler, n && (e(t, "wheel", n), e(t, "touchmove", n));
}, Io = {
	startColor: "green",
	endColor: "red",
	indent: 0,
	fontSize: "16px",
	fontWeight: "normal"
}, Lo = {
	toggleActions: "play",
	anticipatePin: 0
}, Ro = {
	top: 0,
	left: 0,
	center: .5,
	bottom: 1,
	right: 1
}, zo = function(e, t) {
	if (eo(e)) {
		var n = e.indexOf("="), r = ~n ? +(e.charAt(n - 1) + 1) * parseFloat(e.substr(n + 1)) : 0;
		~n && (e.indexOf("%") > n && (r *= t / 100), e = e.substr(0, n - 1)), e = r + (e in Ro ? Ro[e] * t : ~e.indexOf("%") ? parseFloat(e) * t / 100 : parseFloat(e) || 0);
	}
	return e;
}, Bo = function(e, t, n, r, i, a, o, s) {
	var c = i.startColor, l = i.endColor, u = i.fontSize, d = i.indent, f = i.fontWeight, p = X.createElement("div"), m = qa(n) || Ri(n, "pinType") === "fixed", h = e.indexOf("scroller") !== -1, g = m ? Z : n.tagName === "IFRAME" ? n.contentDocument.body : n, _ = e.indexOf("start") !== -1, v = _ ? c : l, y = "border-color:" + v + ";font-size:" + u + ";color:" + v + ";font-weight:" + f + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
	return y += "position:" + ((h || s) && m ? "fixed;" : "absolute;"), (h || s || !m) && (y += (r === qi ? lo : uo) + ":" + (a + parseFloat(d)) + "px;"), o && (y += "box-sizing:border-box;text-align:left;width:" + o.offsetWidth + "px;"), p._isStart = _, p.setAttribute("class", "gsap-marker-" + e + (t ? " marker-" + t : "")), p.style.cssText = y, p.innerText = t || t === 0 ? e + "-" + t : e, g.children[0] ? g.insertBefore(p, g.children[0]) : g.appendChild(p), p._offset = p["offset" + r.op.d2], Vo(p, 0, r, _), p;
}, Vo = function(e, t, n, r) {
	var i = { display: "block" }, a = n[r ? "os2" : "p2"], o = n[r ? "p2" : "os2"];
	e._isFlipped = r, i[n.a + "Percent"] = r ? -100 : 0, i[n.a] = r ? "1px" : 0, i["border" + a + bo] = 1, i["border" + o + bo] = 0, i[n.p] = t + "px", J.set(e, i);
}, Q = [], Ho = {}, Uo, Wo = function() {
	return Pa() - Ia > 34 && (Uo ||= requestAnimationFrame(ps));
}, Go = function() {
	(!xa || !xa.isPressed || xa.startX > Z.clientWidth) && (q.cache++, xa ? Uo ||= requestAnimationFrame(ps) : ps(), Ia || Zo("scrollStart"), Ia = Pa());
}, Ko = function() {
	wa = Y.innerWidth, Ca = Y.innerHeight;
}, qo = function(e) {
	q.cache++, (e === !0 || !da && !ba && !X.fullscreenElement && !X.webkitFullscreenElement && (!Sa || wa !== Y.innerWidth || Math.abs(Y.innerHeight - Ca) > Y.innerHeight * .25)) && oa.restart(!0);
}, Jo = {}, Yo = [], Xo = function e() {
	return Po($, "scrollEnd", e) || ls(!0);
}, Zo = function(e) {
	return Jo[e] && Jo[e].map(function(e) {
		return e();
	}) || Yo;
}, Qo = [], $o = function(e) {
	for (var t = 0; t < Qo.length; t += 5) (!e || Qo[t + 4] && Qo[t + 4].query === e) && (Qo[t].style.cssText = Qo[t + 1], Qo[t].getBBox && Qo[t].setAttribute("transform", Qo[t + 2] || ""), Qo[t + 3].uncache = 1);
}, es = function() {
	return q.forEach(function(e) {
		return to(e) && ++e.cacheID && (e.rec = e());
	});
}, ts = function(e, t) {
	var n;
	for (ma = 0; ma < Q.length; ma++) n = Q[ma], n && (!t || n._ctx === t) && (e ? n.kill(1) : n.revert(!0, !0));
	Aa = !0, t && $o(t), t || Zo("revert");
}, ns = function(e, t) {
	q.cache++, (t || !rs) && q.forEach(function(e) {
		return to(e) && e.cacheID++ && (e.rec = 0);
	}), eo(e) && (Y.history.scrollRestoration = Da = e);
}, rs, is = 0, as, os = function() {
	if (as !== is) {
		var e = as = is;
		requestAnimationFrame(function() {
			return e === is && ls(!0);
		});
	}
}, ss = function() {
	Z.appendChild(Oa), ka = !xa && Oa.offsetHeight || Y.innerHeight, Z.removeChild(Oa);
}, cs = function(e) {
	return sa(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(t) {
		return t.style.display = e ? "none" : "block";
	});
}, ls = function(e, t) {
	if (ia = X.documentElement, Z = X.body, aa = [
		Y,
		X,
		ia,
		Z
	], Ia && !e && !Aa) {
		No($, "scrollEnd", Xo);
		return;
	}
	ss(), rs = $.isRefreshing = !0, Aa || es();
	var n = Zo("refreshInit");
	va && $.sort(), t || ts(), q.forEach(function(e) {
		to(e) && (e.smooth && (e.target.style.scrollBehavior = "auto"), e(0));
	}), Q.slice(0).forEach(function(e) {
		return e.refresh();
	}), Aa = !1, Q.forEach(function(e) {
		if (e._subPinOffset && e.pin) {
			var t = e.vars.horizontal ? "offsetWidth" : "offsetHeight", n = e.pin[t];
			e.revert(!0, 1), e.adjustPinSpacing(e.pin[t] - n), e.refresh();
		}
	}), ja = 1, cs(!0), Q.forEach(function(e) {
		var t = Qa(e.scroller, e._dir), n = e.vars.end === "max" || e._endClamp && e.end > t, r = e._startClamp && e.start >= t;
		(n || r) && e.setPositions(r ? t - 1 : e.start, n ? Math.max(r ? t : e.start + 1, t) : e.end, !0);
	}), cs(!1), ja = 0, n.forEach(function(e) {
		return e && e.render && e.render(-1);
	}), q.forEach(function(e) {
		to(e) && (e.smooth && requestAnimationFrame(function() {
			return e.target.style.scrollBehavior = "smooth";
		}), e.rec && e(e.rec));
	}), ns(Da, 1), oa.pause(), is++, rs = 2, ps(2), Q.forEach(function(e) {
		return to(e.vars.onRefresh) && e.vars.onRefresh(e);
	}), rs = $.isRefreshing = !1, Zo("refresh");
}, us = 0, ds = 1, fs, ps = function(e) {
	if (e === 2 || !rs && !Aa) {
		$.isUpdating = !0, fs && fs.update(0);
		var t = Q.length, n = Pa(), r = n - Fa >= 50, i = t && Q[0].scroll();
		if (ds = us > i ? -1 : 1, rs || (us = i), r && (Ia && !fa && n - Ia > 200 && (Ia = 0, Zo("scrollEnd")), la = Fa, Fa = n), ds < 0) {
			for (ma = t; ma-- > 0;) Q[ma] && Q[ma].update(0, r);
			ds = 1;
		} else for (ma = 0; ma < t; ma++) Q[ma] && Q[ma].update(0, r);
		$.isUpdating = !1;
	}
	Uo = 0;
}, ms = [
	so,
	co,
	uo,
	lo,
	yo + _o,
	yo + mo,
	yo + go,
	yo + ho,
	"display",
	"flexShrink",
	"float",
	"zIndex",
	"gridColumnStart",
	"gridColumnEnd",
	"gridRowStart",
	"gridRowEnd",
	"gridArea",
	"justifySelf",
	"alignSelf",
	"placeSelf",
	"order"
], hs = ms.concat([
	fo,
	po,
	"boxSizing",
	"max" + bo,
	"max" + xo,
	"position",
	yo,
	vo,
	vo + go,
	vo + mo,
	vo + _o,
	vo + ho
]), gs = function(e, t, n) {
	ys(n);
	var r = e._gsap;
	if (r.spacerIsNative) ys(r.spacerState);
	else if (e._gsap.swappedIn) {
		var i = t.parentNode;
		i && (i.insertBefore(e, t), i.removeChild(t));
	}
	e._gsap.swappedIn = !1;
}, _s = function(e, t, n, r) {
	if (!e._gsap.swappedIn) {
		for (var i = ms.length, a = t.style, o = e.style, s; i--;) s = ms[i], a[s] = n[s];
		a.position = n.position === "absolute" ? "absolute" : "relative", n.display === "inline" && (a.display = "inline-block"), o[uo] = o[lo] = "auto", a.flexBasis = n.flexBasis || "auto", a.overflow = "visible", a.boxSizing = "border-box", a[fo] = Do(e, Ki) + So, a[po] = Do(e, qi) + So, a[vo] = o[yo] = o[co] = o[so] = "0", ys(r), o[fo] = o["max" + bo] = n[fo], o[po] = o["max" + xo] = n[po], o[vo] = n[vo], e.parentNode !== t && (e.parentNode.insertBefore(t, e), t.appendChild(e)), e._gsap.swappedIn = !0;
	}
}, vs = /([A-Z])/g, ys = function(e) {
	if (e) {
		var t = e.t.style, n = e.length, r = 0, i, a;
		for ((e.t._gsap || J.core.getCache(e.t)).uncache = 1; r < n; r += 2) a = e[r + 1], i = e[r], a ? t[i] = a : t[i] && t.removeProperty(i.replace(vs, "-$1").toLowerCase());
	}
}, bs = function(e) {
	for (var t = hs.length, n = e.style, r = [], i = 0; i < t; i++) r.push(hs[i], n[hs[i]]);
	return r.t = e, r;
}, xs = function(e, t, n) {
	for (var r = [], i = e.length, a = n ? 8 : 0, o; a < i; a += 2) o = e[a], r.push(o, o in t ? t[o] : e[a + 1]);
	return r.t = e.t, r;
}, Ss = {
	left: 0,
	top: 0
}, Cs = function(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
	to(e) && (e = e(s)), eo(e) && e.substr(0, 3) === "max" && (e = d + (e.charAt(4) === "=" ? zo("0" + e.substr(3), n) : 0));
	var m = f ? f.time() : 0, h, g, _;
	if (f && f.seek(0), isNaN(e) || (e = +e), no(e)) f && (e = J.utils.mapRange(f.scrollTrigger.start, f.scrollTrigger.end, 0, d, e)), o && Vo(o, n, r, !0);
	else {
		to(t) && (t = t(s));
		var v = (e || "0").split(" "), y, b, x, S;
		_ = Ji(t, s) || Z, y = Eo(_) || {}, (!y || !y.left && !y.top) && Co(_).display === "none" && (S = _.style.display, _.style.display = "block", y = Eo(_), S ? _.style.display = S : _.style.removeProperty("display")), b = zo(v[0], y[r.d]), x = zo(v[1] || "0", n), e = y[r.p] - c[r.p] - l + b + i - x, o && Vo(o, x, r, n - x < 20 || o._isStart && x > 20), n -= n - x;
	}
	if (p && (s[p] = e || -.001, e < 0 && (e = 0)), a) {
		var C = e + n, w = a._isStart;
		h = "scroll" + r.d2, Vo(a, C, r, w && C > 20 || !w && (u ? Math.max(Z[h], ia[h]) : a.parentNode[h]) <= C + 1), u && (c = Eo(o), u && (a.style[r.op.p] = c[r.op.p] - r.op.m - a._offset + So));
	}
	return f && _ && (h = Eo(_), f.seek(d), g = Eo(_), f._caScrollDist = h[r.p] - g[r.p], e = e / f._caScrollDist * d), f && f.seek(m), f ? e : Math.round(e);
}, ws = /(webkit|moz|length|cssText|inset)/i, Ts = function(e, t, n, r) {
	if (e.parentNode !== t) {
		var i = e.style, a, o;
		if (t === Z) {
			for (a in e._stOrig = i.cssText, o = Co(e), o) !+a && !ws.test(a) && o[a] && typeof i[a] == "string" && a !== "0" && (i[a] = o[a]);
			i.top = n, i.left = r;
		} else i.cssText = e._stOrig;
		J.core.getCache(e).uncache = 1, t.appendChild(e);
	}
}, Es = function(e, t, n) {
	var r = t, i = r;
	return function(t) {
		var a = Math.round(e());
		return a !== r && a !== i && Math.abs(a - r) > 3 && Math.abs(a - i) > 3 && (t = a, n && n()), i = r, r = Math.round(t), r;
	};
}, Ds = function(e, t, n) {
	var r = {};
	r[t.p] = "+=" + n, J.set(e, r);
}, Os = function(e, t) {
	var n = Xi(e, t), r = "_scroll" + t.p2, i = function t(i, a, o, s, c) {
		var l = t.tween, u = a.onComplete, d = {};
		o ||= n();
		var f = Es(n, o, function() {
			l.kill(), t.tween = 0;
		});
		return c = s && c || 0, s ||= i - o, l && l.kill(), a[r] = i, a.inherit = !1, a.modifiers = d, d[r] = function() {
			return f(o + s * l.ratio + c * l.ratio * l.ratio);
		}, a.onUpdate = function() {
			q.cache++, t.tween && ps();
		}, a.onComplete = function() {
			t.tween = 0, u && u.call(l);
		}, l = t.tween = J.to(e, a), l;
	};
	return e[r] = n, n.wheelHandler = function() {
		return i.tween && i.tween.kill() && (i.tween = 0);
	}, No(e, "wheel", n.wheelHandler), $.isTouch && No(e, "touchmove", n.wheelHandler), i;
}, $ = /*#__PURE__*/ function() {
	function e(t, n) {
		ra || e.register(J) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), Ea(this), this.init(t, n);
	}
	var t = e.prototype;
	return t.init = function(t, n) {
		if (this.progress = this.start = 0, this.vars && this.kill(!0, !0), !La) {
			this.update = this.refresh = this.kill = Ua;
			return;
		}
		t = To(eo(t) || no(t) || t.nodeType ? { trigger: t } : t, Lo);
		var r = t, i = r.onUpdate, a = r.toggleClass, o = r.id, s = r.onToggle, c = r.onRefresh, l = r.scrub, u = r.trigger, d = r.pin, f = r.pinSpacing, p = r.invalidateOnRefresh, m = r.anticipatePin, h = r.onScrubComplete, g = r.onSnapComplete, _ = r.once, v = r.snap, y = r.pinReparent, b = r.pinSpacer, x = r.containerAnimation, S = r.fastScrollEnd, C = r.preventOverlaps, w = t.horizontal || t.containerAnimation && t.horizontal !== !1 ? Ki : qi, T = !l && l !== 0, E = Ji(t.scroller || Y), D = J.core.getCache(E), O = qa(E), k = ("pinType" in t ? t.pinType : Ri(E, "pinType") || O && "fixed") === "fixed", A = [
			t.onEnter,
			t.onLeave,
			t.onEnterBack,
			t.onLeaveBack
		], j = T && t.toggleActions.split(" "), M = "markers" in t ? t.markers : Lo.markers, ee = O ? 0 : parseFloat(Co(E)["border" + w.p2 + bo]) || 0, N = this, P = t.onRefreshInit && function() {
			return t.onRefreshInit(N);
		}, te = Xa(E, O, w), ne = Za(E, O), F = 0, re = 0, I = 0, L = Xi(E, w), ie, R, ae, oe, se, z, ce, le, B, ue, de, fe, pe, me, he, ge, _e, ve, V, ye, H, U, be, xe, Se, Ce, we, Te, Ee, W, De, G, Oe, ke, Ae, je, Me, Ne, Pe;
		if (N._startClamp = N._endClamp = !1, N._dir = w, m *= 45, N.scroller = E, N.scroll = x ? x.time.bind(x) : L, oe = L(), N.vars = t, n ||= t.animation, "refreshPriority" in t && (va = 1, t.refreshPriority === -9999 && (fs = N)), D.tweenScroll = D.tweenScroll || {
			top: Os(E, qi),
			left: Os(E, Ki)
		}, N.tweenTo = ie = D.tweenScroll[w.p], N.scrubDuration = function(e) {
			Oe = no(e) && e, Oe ? G ? G.duration(e) : G = J.to(n, {
				ease: "expo",
				totalProgress: "+=0",
				inherit: !1,
				duration: Oe,
				paused: !0,
				onComplete: function() {
					return h && h(N);
				}
			}) : (G && G.progress(1).kill(), G = 0);
		}, n && (n.vars.lazy = !1, n._initted && !N.isReverted || n.vars.immediateRender !== !1 && t.immediateRender !== !1 && n.duration() && n.render(0, !0, !0), N.animation = n.pause(), n.scrollTrigger = N, N.scrubDuration(l), W = 0, o ||= n.vars.id), v && ((!ro(v) || v.push) && (v = { snapTo: v }), "scrollBehavior" in Z.style && J.set(O ? [Z, ia] : E, { scrollBehavior: "auto" }), q.forEach(function(e) {
			return to(e) && e.target === (O ? X.scrollingElement || ia : E) && (e.smooth = !1);
		}), ae = to(v.snapTo) ? v.snapTo : v.snapTo === "labels" ? ko(n) : v.snapTo === "labelsDirectional" ? jo(n) : v.directional === !1 ? J.utils.snap(v.snapTo) : function(e, t) {
			return Ao(v.snapTo)(e, Pa() - re < 500 ? 0 : t.direction);
		}, ke = v.duration || {
			min: .1,
			max: 2
		}, ke = ro(ke) ? ca(ke.min, ke.max) : ca(ke, ke), Ae = J.delayedCall(v.delay || Oe / 2 || .1, function() {
			var e = L(), t = Pa() - re < 500, r = ie.tween;
			if ((t || Math.abs(N.getVelocity()) < 10) && !r && !fa && F !== e) {
				var i = (e - z) / me, a = n && !T ? n.totalProgress() : i, o = t ? 0 : (a - De) / (Pa() - la) * 1e3 || 0, s = J.utils.clamp(-i, 1 - i, oo(o / 2) * o / .185), c = i + (v.inertia === !1 ? 0 : s), l, u, d = v, f = d.onStart, p = d.onInterrupt, m = d.onComplete;
				if (l = ae(c, N), no(l) || (l = c), u = Math.max(0, Math.round(z + l * me)), e <= ce && e >= z && u !== e) {
					if (r && !r._initted && r.data <= oo(u - e)) return;
					v.inertia === !1 && (s = l - i), ie(u, {
						duration: ke(oo(Math.max(oo(c - a), oo(l - a)) * .185 / o / .05 || 0)),
						ease: v.ease || "power3",
						data: oo(u - e),
						onInterrupt: function() {
							return Ae.restart(!0) && p && ao(N, p);
						},
						onComplete: function() {
							N.update(), F = L(), n && !T && (G ? G.resetTo("totalProgress", l, n._tTime / n._tDur) : n.progress(l)), W = De = n && !T ? n.totalProgress() : N.progress, g && g(N), m && ao(N, m);
						}
					}, e, s * me, u - e - s * me), f && ao(N, f, ie.tween);
				}
			} else N.isActive && F !== e && Ae.restart(!0);
		}).pause()), o && (Ho[o] = N), u = N.trigger = Ji(u || d !== !0 && d), Pe = u && u._gsap && u._gsap.stRevert, Pe &&= Pe(N), d = d === !0 ? u : Ji(d), eo(a) && (a = {
			targets: u,
			className: a
		}), d && (f === !1 || f === yo || (f = !f && d.parentNode && d.parentNode.style && Co(d.parentNode).display === "flex" ? !1 : vo), N.pin = d, R = J.core.getCache(d), R.spacer ? he = R.pinState : (b && (b = Ji(b), b && !b.nodeType && (b = b.current || b.nativeElement), R.spacerIsNative = !!b, b && (R.spacerState = bs(b))), R.spacer = ve = b || X.createElement("div"), ve.classList.add("pin-spacer"), o && ve.classList.add("pin-spacer-" + o), R.pinState = he = bs(d)), t.force3D !== !1 && J.set(d, { force3D: !0 }), N.spacer = ve = R.spacer, Ee = Co(d), xe = Ee[f + w.os2], ye = J.getProperty(d), H = J.quickSetter(d, w.a, So), _s(d, ve, Ee), _e = bs(d)), M) {
			fe = ro(M) ? To(M, Io) : Io, ue = Bo("scroller-start", o, E, w, fe, 0), de = Bo("scroller-end", o, E, w, fe, 0, ue), V = ue["offset" + w.op.d2];
			var Fe = Ji(Ri(E, "content") || E);
			le = this.markerStart = Bo("start", o, Fe, w, fe, V, 0, x), B = this.markerEnd = Bo("end", o, Fe, w, fe, V, 0, x), x && (Ne = J.quickSetter([le, B], w.a, So)), !k && !(Pi.length && Ri(E, "fixedMarkers") === !0) && (wo(O ? Z : E), J.set([ue, de], { force3D: !0 }), Ce = J.quickSetter(ue, w.a, So), Te = J.quickSetter(de, w.a, So));
		}
		if (x) {
			var Ie = x.vars.onUpdate, Le = x.vars.onUpdateParams;
			x.eventCallback("onUpdate", function() {
				N.update(0, 0, 1), Ie && Ie.apply(x, Le || []);
			});
		}
		if (N.previous = function() {
			return Q[Q.indexOf(N) - 1];
		}, N.next = function() {
			return Q[Q.indexOf(N) + 1];
		}, N.revert = function(e, t) {
			if (!t) return N.kill(!0);
			var r = e !== !1 || !N.enabled, i = da;
			r !== N.isReverted && (r && (je = Math.max(L(), N.scroll.rec || 0), I = N.progress, Me = n && n.progress()), le && [
				le,
				B,
				ue,
				de
			].forEach(function(e) {
				return e.style.display = r ? "none" : "block";
			}), r && (da = N, N.update(r)), d && (!y || !N.isActive) && (r ? gs(d, ve, he) : _s(d, ve, Co(d), Se)), r || N.update(r), da = i, N.isReverted = r);
		}, N.refresh = function(r, i, a, o) {
			if (!da && N.enabled || i) {
				if (d && r && Ia) {
					No(e, "scrollEnd", Xo);
					return;
				}
				!rs && P && P(N), da = N, ie.tween && !a && (ie.tween.kill(), ie.tween = 0), G && G.pause(), p && n && (n.revert({ kill: !1 }).invalidate(), n.getChildren ? n.getChildren(!0, !0, !1).forEach(function(e) {
					return e.vars.immediateRender && e.render(0, !0, !0);
				}) : n.vars.immediateRender && n.render(0, !0, !0)), N.isReverted || N.revert(!0, !0), N._subPinOffset = !1;
				var s = te(), l = ne(), m = x ? x.duration() : Qa(E, w), h = me <= .01 || !me, g = 0, _ = o || 0, v = ro(a) ? a.end : t.end, b = t.endTrigger || u, S = ro(a) ? a.start : t.start || (t.start === 0 || !u ? 0 : d ? "0 0" : "0 100%"), C = N.pinnedContainer = t.pinnedContainer && Ji(t.pinnedContainer, N), D = u && Math.max(0, Q.indexOf(N)) || 0, A = D, j, R, ae, fe, V, H, xe, Ce, Te, Ee, W, De, Oe;
				for (M && ro(a) && (De = J.getProperty(ue, w.p), Oe = J.getProperty(de, w.p)); A-- > 0;) H = Q[A], H.end || H.refresh(0, 1) || (da = N), xe = H.pin, xe && (xe === u || xe === d || xe === C) && !H.isReverted && (Ee ||= [], Ee.unshift(H), H.revert(!0, !0)), H !== Q[A] && (D--, A--);
				for (to(S) && (S = S(N)), S = Ra(S, "start", N), z = Cs(S, u, s, w, L(), le, ue, N, l, ee, k, m, x, N._startClamp && "_startClamp") || (d ? -.001 : 0), to(v) && (v = v(N)), eo(v) && !v.indexOf("+=") && (~v.indexOf(" ") ? v = (eo(S) ? S.split(" ")[0] : "") + v : (g = zo(v.substr(2), s), v = eo(S) ? S : (x ? J.utils.mapRange(0, x.duration(), x.scrollTrigger.start, x.scrollTrigger.end, z) : z) + g, b = u)), v = Ra(v, "end", N), ce = Math.max(z, Cs(v || (b ? "100% 0" : m), b, s, w, L() + g, B, de, N, l, ee, k, m, x, N._endClamp && "_endClamp")) || -.001, g = 0, A = D; A--;) H = Q[A] || {}, xe = H.pin, xe && H.start - H._pinPush <= z && !x && H.end > 0 && (j = H.end - (N._startClamp ? Math.max(0, H.start) : H.start), (xe === u && H.start - H._pinPush < z || xe === C) && isNaN(S) && (g += j * (1 - H.progress)), xe === d && (_ += j));
				if (z += g, ce += g, N._startClamp && (N._startClamp += g), N._endClamp && !rs && (N._endClamp = ce || -.001, ce = Math.min(ce, Qa(E, w))), me = ce - z || (z -= .01) && .001, h && (I = J.utils.clamp(0, 1, J.utils.normalize(z, ce, je))), N._pinPush = _, le && g && (j = {}, j[w.a] = "+=" + g, C && (j[w.p] = "-=" + L()), J.set([le, B], j)), d && !(ja && N.end >= Qa(E, w))) j = Co(d), fe = w === qi, ae = L(), U = parseFloat(ye(w.a)) + _, !m && ce > 1 && (W = (O ? X.scrollingElement || ia : E).style, W = {
					style: W,
					value: W["overflow" + w.a.toUpperCase()]
				}, O && Co(Z)["overflow" + w.a.toUpperCase()] !== "scroll" && (W.style["overflow" + w.a.toUpperCase()] = "scroll")), _s(d, ve, j), _e = bs(d), R = Eo(d, !0), Ce = k && Xi(E, fe ? Ki : qi)(), f ? (Se = [f + w.os2, me + _ + So], Se.t = ve, A = f === vo ? Do(d, w) + me + _ : 0, A && (Se.push(w.d, A + So), ve.style.flexBasis !== "auto" && (ve.style.flexBasis = A + So)), ys(Se), C && Q.forEach(function(e) {
					e.pin === C && e.vars.pinSpacing !== !1 && (e._subPinOffset = !0);
				}), k && L(je)) : (A = Do(d, w), A && ve.style.flexBasis !== "auto" && (ve.style.flexBasis = A + So)), k && (V = {
					top: R.top + (fe ? ae - z : Ce) + So,
					left: R.left + (fe ? Ce : ae - z) + So,
					boxSizing: "border-box",
					position: "fixed"
				}, V[fo] = V["max" + bo] = Math.ceil(R.width) + So, V[po] = V["max" + xo] = Math.ceil(R.height) + So, V[yo] = V[yo + go] = V[yo + mo] = V[yo + _o] = V[yo + ho] = "0", V[vo] = j[vo], V[vo + go] = j[vo + go], V[vo + mo] = j[vo + mo], V[vo + _o] = j[vo + _o], V[vo + ho] = j[vo + ho], ge = xs(he, V, y), rs && L(0)), n ? (Te = n._initted, ya(1), n.render(n.duration(), !0, !0), be = ye(w.a) - U + me + _, we = Math.abs(me - be) > 1, k && we && ge.splice(ge.length - 2, 2), n.render(0, !0, !0), Te || n.invalidate(!0), n.parent || n.totalTime(n.totalTime()), ya(0)) : be = me, W && (W.value ? W.style["overflow" + w.a.toUpperCase()] = W.value : W.style.removeProperty("overflow-" + w.a));
				else if (u && L() && !x) for (R = u.parentNode; R && R !== Z;) R._pinOffset && (z -= R._pinOffset, ce -= R._pinOffset), R = R.parentNode;
				Ee && Ee.forEach(function(e) {
					return e.revert(!1, !0);
				}), N.start = z, N.end = ce, oe = se = rs ? je : L(), !x && !rs && (oe < je && L(je), N.scroll.rec = 0), N.revert(!1, !0), re = Pa(), Ae && (F = -1, Ae.restart(!0)), da = 0, n && T && (n._initted || Me) && n.progress() !== Me && n.progress(Me || 0, !0).render(n.time(), !0, !0), (h || I !== N.progress || x || p || n && !n._initted) && (n && !T && (n._initted || I || n.vars.immediateRender !== !1) && n.totalProgress(x && z < -.001 && !I ? J.utils.normalize(z, ce, 0) : I, !0), N.progress = h || (oe - z) / me === I ? 0 : I), d && f && (ve._pinOffset = Math.round(N.progress * be)), G && G.invalidate(), isNaN(De) || (De -= J.getProperty(ue, w.p), Oe -= J.getProperty(de, w.p), Ds(ue, w, De), Ds(le, w, De - (o || 0)), Ds(de, w, Oe), Ds(B, w, Oe - (o || 0))), h && !rs && N.update(), c && !rs && !pe && (pe = !0, c(N), pe = !1);
			}
		}, N.getVelocity = function() {
			return (L() - se) / (Pa() - la) * 1e3 || 0;
		}, N.endAnimation = function() {
			io(N.callbackAnimation), n && (G ? G.progress(1) : n.paused() ? T || io(n, N.direction < 0, 1) : io(n, n.reversed()));
		}, N.labelToScroll = function(e) {
			return n && n.labels && (z || N.refresh() || z) + n.labels[e] / n.duration() * me || 0;
		}, N.getTrailing = function(e) {
			var t = Q.indexOf(N), n = N.direction > 0 ? Q.slice(0, t).reverse() : Q.slice(t + 1);
			return (eo(e) ? n.filter(function(t) {
				return t.vars.preventOverlaps === e;
			}) : n).filter(function(e) {
				return N.direction > 0 ? e.end <= z : e.start >= ce;
			});
		}, N.update = function(e, t, r) {
			if (!x || r || e) {
				var o = rs === !0 ? je : N.scroll(), c = e ? 0 : (o - z) / me, u = c < 0 ? 0 : c > 1 ? 1 : c || 0, p = N.progress, h, g, b, D, O, M, ee, P;
				if (t && (se = oe, oe = x ? L() : o, v && (De = W, W = n && !T ? n.totalProgress() : u)), m && d && !da && !Na && Ia && (!u && z < o + (o - se) / (Pa() - la) * m ? u = 1e-4 : u === 1 && ce > o + (o - se) / (Pa() - la) * m && (u = .9999)), u !== p && N.enabled) {
					if (h = N.isActive = !!u && u < 1, g = !!p && p < 1, M = h !== g, O = M || !!u != !!p, N.direction = u > p ? 1 : -1, N.progress = u, O && !da && (b = u && !p ? 0 : u === 1 ? 1 : p === 1 ? 2 : 3, T && (D = !M && j[b + 1] !== "none" && j[b + 1] || j[b], P = n && (D === "complete" || D === "reset" || D in n))), C && (M || P) && (P || l || !n) && (to(C) ? C(N) : N.getTrailing(C).forEach(function(e) {
						return e.endAnimation();
					})), T || (G && !da && !Na ? (G._dp._time - G._start !== G._time && G.render(G._dp._time - G._start), G.resetTo ? G.resetTo("totalProgress", u, n._tTime / n._tDur) : (G.vars.totalProgress = u, G.invalidate().restart())) : n && n.totalProgress(u, !!(da && (re || e)))), d) {
						if (e && f && (ve.style[f + w.os2] = xe), !k) H(Wa(U + be * u));
						else if (O) {
							if (ee = !e && u > p && ce + 1 > o && o + 1 >= Qa(E, w), y) {
								if (!e && (h || ee)) {
									var te = Eo(d, !0), ne = o - z;
									Ts(d, Z, te.top + (w === qi ? ne : 0) + So, te.left + (w === qi ? 0 : ne) + So);
								} else Ts(d, ve);
							}
							ys(h || ee ? ge : _e), we && u < 1 && h || H(U + (u === 1 && !ee ? be : 0));
						}
					}
					v && !ie.tween && !da && !Na && Ae.restart(!0), a && (M || _ && u && (u < 1 || !Ma)) && sa(a.targets).forEach(function(e) {
						return e.classList[h || _ ? "add" : "remove"](a.className);
					}), i && !T && !e && i(N), O && !da ? (T && (P && (D === "complete" ? n.pause().totalProgress(1) : D === "reset" ? n.restart(!0).pause() : D === "restart" ? n.restart(!0) : n[D]()), i && i(N)), (M || !Ma) && (s && M && ao(N, s), A[b] && ao(N, A[b]), _ && (u === 1 ? N.kill(!1, 1) : A[b] = 0), M || (b = u === 1 ? 1 : 3, A[b] && ao(N, A[b]))), S && !h && Math.abs(N.getVelocity()) > (no(S) ? S : 2500) && (io(N.callbackAnimation), G ? G.progress(1) : io(n, D === "reverse" ? 1 : !u, 1))) : T && i && !da && i(N);
				}
				if (Te) {
					var F = x ? o / x.duration() * (x._caScrollDist || 0) : o;
					Ce(F + +!!ue._isFlipped), Te(F);
				}
				Ne && Ne(-o / x.duration() * (x._caScrollDist || 0));
			}
		}, N.enable = function(t, n) {
			N.enabled || (N.enabled = !0, No(E, "resize", qo), O || No(E, "scroll", Go), P && No(e, "refreshInit", P), t !== !1 && (N.progress = I = 0, oe = se = F = L()), n !== !1 && N.refresh());
		}, N.getTween = function(e) {
			return e && ie ? ie.tween : G;
		}, N.setPositions = function(e, t, n, r) {
			if (x) {
				var i = x.scrollTrigger, a = x.duration(), o = i.end - i.start;
				e = i.start + o * e / a, t = i.start + o * t / a;
			}
			N.refresh(!1, !1, {
				start: za(e, n && !!N._startClamp),
				end: za(t, n && !!N._endClamp)
			}, r), N.update();
		}, N.adjustPinSpacing = function(e) {
			if (Se && e) {
				var t = Se.indexOf(w.d) + 1;
				Se[t] = parseFloat(Se[t]) + e + So, Se[1] = parseFloat(Se[1]) + e + So, ys(Se);
			}
		}, N.disable = function(t, n) {
			if (t !== !1 && N.revert(!0, !0), N.enabled && (N.enabled = N.isActive = !1, n || G && G.pause(), je = 0, R && (R.uncache = 1), P && Po(e, "refreshInit", P), Ae && (Ae.pause(), ie.tween && ie.tween.kill() && (ie.tween = 0)), !O)) {
				for (var r = Q.length; r--;) if (Q[r].scroller === E && Q[r] !== N) return;
				Po(E, "resize", qo), O || Po(E, "scroll", Go);
			}
		}, N.kill = function(e, r) {
			N.disable(e, r), G && !r && G.kill(), o && delete Ho[o];
			var i = Q.indexOf(N);
			i >= 0 && Q.splice(i, 1), i === ma && ds > 0 && ma--, i = 0, Q.forEach(function(e) {
				return e.scroller === N.scroller && (i = 1);
			}), i || rs || (N.scroll.rec = 0), n && (n.scrollTrigger = null, e && n.revert({ kill: !1 }), r || n.kill()), le && [
				le,
				B,
				ue,
				de
			].forEach(function(e) {
				return e.parentNode && e.parentNode.removeChild(e);
			}), fs === N && (fs = 0), d && (R && (R.uncache = 1), i = 0, Q.forEach(function(e) {
				return e.pin === d && i++;
			}), i || (R.spacer = 0)), t.onKill && t.onKill(N);
		}, Q.push(N), N.enable(!1, !1), Pe && Pe(N), n && n.add && !me) {
			var Re = N.update;
			N.update = function() {
				N.update = Re, q.cache++, z || ce || N.refresh();
			}, J.delayedCall(.01, N.update), me = .01, z = ce = 0;
		} else N.refresh();
		d && os();
	}, e.register = function(t) {
		return ra ||= (J = t || Ka(), Ga() && window.document && e.enable(), La), ra;
	}, e.defaults = function(e) {
		if (e) for (var t in e) Lo[t] = e[t];
		return Lo;
	}, e.disable = function(e, t) {
		La = 0, Q.forEach(function(n) {
			return n[t ? "kill" : "disable"](e);
		}), Po(Y, "wheel", Go), Po(X, "scroll", Go), clearInterval(ua), Po(X, "touchcancel", Ua), Po(Z, "touchstart", Ua), Mo(Po, X, "pointerdown,touchstart,mousedown", Va), Mo(Po, X, "pointerup,touchend,mouseup", Ha), oa.kill(), $a(Po);
		for (var n = 0; n < q.length; n += 3) Fo(Po, q[n], q[n + 1]), Fo(Po, q[n], q[n + 2]);
	}, e.enable = function() {
		if (Y = window, X = document, ia = X.documentElement, Z = X.body, J) {
			if (sa = J.utils.toArray, ca = J.utils.clamp, Ea = J.core.context || Ua, ya = J.core.suppressOverwrites || Ua, Da = Y.history.scrollRestoration || "auto", us = Y.pageYOffset || 0, J.core.globals("ScrollTrigger", e), Z) {
				La = 1, Oa = document.createElement("div"), Oa.style.height = "100vh", Oa.style.position = "absolute", ss(), Ba(), na.register(J), e.isTouch = na.isTouch, Ta = na.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), Sa = na.isTouch === 1, No(Y, "wheel", Go), aa = [
					Y,
					X,
					ia,
					Z
				], J.matchMedia ? (e.matchMedia = function(e) {
					var t = J.matchMedia(), n;
					for (n in e) t.add(n, e[n]);
					return t;
				}, J.addEventListener("matchMediaInit", function() {
					es(), ts();
				}), J.addEventListener("matchMediaRevert", function() {
					return $o();
				}), J.addEventListener("matchMedia", function() {
					ls(0, 1), Zo("matchMedia");
				}), J.matchMedia().add("(orientation: portrait)", function() {
					return Ko(), Ko;
				})) : console.warn("Requires GSAP 3.11.0 or later"), Ko(), No(X, "scroll", Go);
				var t = Z.hasAttribute("style"), n = Z.style, r = n.borderTopStyle, i = J.core.Animation.prototype, a, o;
				for (i.revert || Object.defineProperty(i, "revert", { value: function() {
					return this.time(-.01, !0);
				} }), n.borderTopStyle = "solid", a = Eo(Z), qi.m = Math.round(a.top + qi.sc()) || 0, Ki.m = Math.round(a.left + Ki.sc()) || 0, r ? n.borderTopStyle = r : n.removeProperty("border-top-style"), t || (Z.setAttribute("style", ""), Z.removeAttribute("style")), ua = setInterval(Wo, 250), J.delayedCall(.5, function() {
					return Na = 0;
				}), No(X, "touchcancel", Ua), No(Z, "touchstart", Ua), Mo(No, X, "pointerdown,touchstart,mousedown", Va), Mo(No, X, "pointerup,touchend,mouseup", Ha), pa = J.utils.checkPrefix("transform"), hs.push(pa), ra = Pa(), oa = J.delayedCall(.2, ls).pause(), _a = [
					X,
					"visibilitychange",
					function() {
						var e = Y.innerWidth, t = Y.innerHeight;
						X.hidden ? (ha = e, ga = t) : (ha !== e || ga !== t) && qo();
					},
					X,
					"DOMContentLoaded",
					ls,
					Y,
					"load",
					ls,
					Y,
					"resize",
					qo
				], $a(No), Q.forEach(function(e) {
					return e.enable(0, 1);
				}), o = 0; o < q.length; o += 3) Fo(Po, q[o], q[o + 1]), Fo(Po, q[o], q[o + 2]);
			} else X && X.addEventListener("DOMContentLoaded", function t() {
				e.enable(), X.removeEventListener("DOMContentLoaded", t);
			});
		}
	}, e.config = function(t) {
		"limitCallbacks" in t && (Ma = !!t.limitCallbacks);
		var n = t.syncInterval;
		n && clearInterval(ua) || (ua = n) && setInterval(Wo, n), "ignoreMobileResize" in t && (Sa = e.isTouch === 1 && t.ignoreMobileResize), "autoRefreshEvents" in t && ($a(Po) || $a(No, t.autoRefreshEvents || "none"), ba = (t.autoRefreshEvents + "").indexOf("resize") === -1);
	}, e.scrollerProxy = function(e, t) {
		var n = Ji(e), r = q.indexOf(n), i = qa(n);
		~r && q.splice(r, i ? 6 : 2), t && (i ? Pi.unshift(Y, t, Z, t, ia, t) : Pi.unshift(n, t));
	}, e.clearMatchMedia = function(e) {
		Q.forEach(function(t) {
			return t._ctx && t._ctx.query === e && t._ctx.kill(!0, !0);
		});
	}, e.isInViewport = function(e, t, n) {
		var r = (eo(e) ? Ji(e) : e).getBoundingClientRect(), i = r[n ? fo : po] * t || 0;
		return n ? r.right - i > 0 && r.left + i < Y.innerWidth : r.bottom - i > 0 && r.top + i < Y.innerHeight;
	}, e.positionInViewport = function(e, t, n) {
		eo(e) && (e = Ji(e));
		var r = e.getBoundingClientRect(), i = r[n ? fo : po], a = t == null ? i / 2 : t in Ro ? Ro[t] * i : ~t.indexOf("%") ? parseFloat(t) * i / 100 : parseFloat(t) || 0;
		return n ? (r.left + a) / Y.innerWidth : (r.top + a) / Y.innerHeight;
	}, e.killAll = function(e) {
		if (Q.slice(0).forEach(function(e) {
			return e.vars.id !== "ScrollSmoother" && e.kill();
		}), e !== !0) {
			var t = Jo.killAll || [];
			Jo = {}, t.forEach(function(e) {
				return e();
			});
		}
	}, e;
}();
$.version = "3.15.0", $.saveStyles = function(e) {
	return e ? sa(e).forEach(function(e) {
		if (e && e.style) {
			var t = Qo.indexOf(e);
			t >= 0 && Qo.splice(t, 5), Qo.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), J.core.getCache(e), Ea());
		}
	}) : Qo;
}, $.revert = function(e, t) {
	return ts(!e, t);
}, $.create = function(e, t) {
	return new $(e, t);
}, $.refresh = function(e) {
	return e ? qo(!0) : (ra || $.register()) && ls(!0);
}, $.update = function(e) {
	return ++q.cache && ps(e === !0 ? 2 : 0);
}, $.clearScrollMemory = ns, $.maxScroll = function(e, t) {
	return Qa(e, t ? Ki : qi);
}, $.getScrollFunc = function(e, t) {
	return Xi(Ji(e), t ? Ki : qi);
}, $.getById = function(e) {
	return Ho[e];
}, $.getAll = function() {
	return Q.filter(function(e) {
		return e.vars.id !== "ScrollSmoother";
	});
}, $.isScrolling = function() {
	return !!Ia;
}, $.snapDirectional = Ao, $.addEventListener = function(e, t) {
	var n = Jo[e] || (Jo[e] = []);
	~n.indexOf(t) || n.push(t);
}, $.removeEventListener = function(e, t) {
	var n = Jo[e], r = n && n.indexOf(t);
	r >= 0 && n.splice(r, 1);
}, $.batch = function(e, t) {
	var n = [], r = {}, i = t.interval || .016, a = t.batchMax || 1e9, o = function(e, t) {
		var n = [], r = [], o = J.delayedCall(i, function() {
			t(n, r), n = [], r = [];
		}).pause();
		return function(e) {
			n.length || o.restart(!0), n.push(e.trigger), r.push(e), a <= n.length && o.progress(1);
		};
	}, s;
	for (s in t) r[s] = s.substr(0, 2) === "on" && to(t[s]) && s !== "onRefreshInit" ? o(s, t[s]) : t[s];
	return to(a) && (a = a(), No($, "refresh", function() {
		return a = t.batchMax();
	})), sa(e).forEach(function(e) {
		var t = {};
		for (s in r) t[s] = r[s];
		t.trigger = e, n.push($.create(t));
	}), n;
};
var ks = function(e, t, n, r) {
	return t > r ? e(r) : t < 0 && e(0), n > r ? (r - t) / (n - t) : n < 0 ? t / (t - n) : 1;
}, As = function e(t, n) {
	n === !0 ? t.style.removeProperty("touch-action") : t.style.touchAction = n === !0 ? "auto" : n ? "pan-" + n + (na.isTouch ? " pinch-zoom" : "") : "none", t === ia && e(Z, n);
}, js = {
	auto: 1,
	scroll: 1
}, Ms = function(e) {
	var t = e.event, n = e.target, r = e.axis, i = (t.changedTouches ? t.changedTouches[0] : t).target, a = i._gsap || J.core.getCache(i), o = Pa(), s;
	if (!a._isScrollT || o - a._isScrollT > 2e3) {
		for (; i && i !== Z && (i.scrollHeight <= i.clientHeight && i.scrollWidth <= i.clientWidth || !(js[(s = Co(i)).overflowY] || js[s.overflowX]));) i = i.parentNode;
		a._isScroll = i && i !== n && !qa(i) && (js[(s = Co(i)).overflowY] || js[s.overflowX]), a._isScrollT = o;
	}
	(a._isScroll || r === "x") && (t.stopPropagation(), t._gsapAllow = !0);
}, Ns = function(e, t, n, r) {
	return na.create({
		target: e,
		capture: !0,
		debounce: !1,
		lockAxis: !0,
		type: t,
		onWheel: r &&= Ms,
		onPress: r,
		onDrag: r,
		onScroll: r,
		onEnable: function() {
			return n && No(X, na.eventTypes[0], Is, !1, !0);
		},
		onDisable: function() {
			return Po(X, na.eventTypes[0], Is, !0);
		}
	});
}, Ps = /(input|label|select|textarea)/i, Fs, Is = function(e) {
	var t = Ps.test(e.target.tagName);
	(t || Fs) && (e._gsapAllow = !0, Fs = t);
}, Ls = function(e) {
	ro(e) || (e = {}), e.preventDefault = e.isNormalizer = e.allowClicks = !0, e.type || (e.type = "wheel,touch"), e.debounce = !!e.debounce, e.id = e.id || "normalizer";
	var t = e, n = t.normalizeScrollX, r = t.momentum, i = t.allowNestedScroll, a = t.onRelease, o, s, c = Ji(e.target) || ia, l = J.core.globals().ScrollSmoother, u = l && l.get(), d = Ta && (e.content && Ji(e.content) || u && e.content !== !1 && !u.smooth() && u.content()), f = Xi(c, qi), p = Xi(c, Ki), m = 1, h = (na.isTouch && Y.visualViewport ? Y.visualViewport.scale * Y.visualViewport.width : Y.outerWidth) / Y.innerWidth, g = 0, _ = to(r) ? function() {
		return r(o);
	} : function() {
		return r || 2.8;
	}, v, y, b = Ns(c, e.type, !0, i), x = function() {
		return y = !1;
	}, S = Ua, C = Ua, w = function() {
		s = Qa(c, qi), C = ca(+!!Ta, s), n && (S = ca(0, Qa(c, Ki))), v = is;
	}, T = function() {
		d._gsap.y = Wa(parseFloat(d._gsap.y) + f.offset) + "px", d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(d._gsap.y) + ", 0, 1)", f.offset = f.cacheID = 0;
	}, E = function() {
		if (y) {
			requestAnimationFrame(x);
			var e = Wa(o.deltaY / 2), t = C(f.v - e);
			if (d && t !== f.v + f.offset) {
				f.offset = t - f.v;
				var n = Wa((parseFloat(d && d._gsap.y) || 0) - f.offset);
				d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + n + ", 0, 1)", d._gsap.y = n + "px", f.cacheID = q.cache, ps();
			}
			return !0;
		}
		f.offset && T(), y = !0;
	}, D, O, k, A, j = function() {
		w(), D.isActive() && D.vars.scrollY > s && (f() > s ? D.progress(1) && f(s) : D.resetTo("scrollY", s));
	};
	return d && J.set(d, { y: "+=0" }), e.ignoreCheck = function(e) {
		return Ta && e.type === "touchmove" && E(e) || m > 1.05 && e.type !== "touchstart" || o.isGesturing || e.touches && e.touches.length > 1;
	}, e.onPress = function() {
		y = !1;
		var e = m;
		m = Wa((Y.visualViewport && Y.visualViewport.scale || 1) / h), D.pause(), e !== m && As(c, m > 1.01 || !n && "x"), O = p(), k = f(), w(), v = is;
	}, e.onRelease = e.onGestureStart = function(e, t) {
		if (f.offset && T(), !t) A.restart(!0);
		else {
			q.cache++;
			var r = _(), i, o;
			n && (i = p(), o = i + r * .05 * -e.velocityX / .227, r *= ks(p, i, o, Qa(c, Ki)), D.vars.scrollX = S(o)), i = f(), o = i + r * .05 * -e.velocityY / .227, r *= ks(f, i, o, Qa(c, qi)), D.vars.scrollY = C(o), D.invalidate().duration(r).play(.01), (Ta && D.vars.scrollY >= s || i >= s - 1) && J.to({}, {
				onUpdate: j,
				duration: r
			});
		}
		a && a(e);
	}, e.onWheel = function() {
		D._ts && D.pause(), Pa() - g > 1e3 && (v = 0, g = Pa());
	}, e.onChange = function(e, t, r, i, a) {
		if (is !== v && w(), t && n && p(S(i[2] === t ? O + (e.startX - e.x) : p() + t - i[1])), r) {
			f.offset && T();
			var o = a[2] === r, s = o ? k + e.startY - e.y : f() + r - a[1], c = C(s);
			o && s !== c && (k += c - s), f(c);
		}
		(r || t) && ps();
	}, e.onEnable = function() {
		As(c, !n && "x"), $.addEventListener("refresh", j), No(Y, "resize", j), f.smooth &&= (f.target.style.scrollBehavior = "auto", p.smooth = !1), b.enable();
	}, e.onDisable = function() {
		As(c, !0), Po(Y, "resize", j), $.removeEventListener("refresh", j), b.kill();
	}, e.lockAxis = e.lockAxis !== !1, o = new na(e), o.iOS = Ta, Ta && !f() && f(1), Ta && J.ticker.add(Ua), A = o._dc, D = J.to(o, {
		ease: "power4",
		paused: !0,
		inherit: !1,
		scrollX: n ? "+=0.1" : "+=0",
		scrollY: "+=0.1",
		modifiers: { scrollY: Es(f, f(), function() {
			return D.pause();
		}) },
		onUpdate: ps,
		onComplete: A.vars.onComplete
	}), o;
};
//#endregion
//#region story.js
$.sort = function(e) {
	if (to(e)) return Q.sort(e);
	var t = Y.pageYOffset || 0;
	return $.getAll().forEach(function(e) {
		return e._sortY = e.trigger ? t + e.trigger.getBoundingClientRect().top : e.start + Y.innerHeight;
	}), Q.sort(e || function(e, t) {
		return (e.vars.refreshPriority || 0) * -1e6 + (e.vars.containerAnimation ? 1e6 : e._sortY) - ((t.vars.containerAnimation ? 1e6 : t._sortY) + (t.vars.refreshPriority || 0) * -1e6);
	});
}, $.observe = function(e) {
	return new na(e);
}, $.normalizeScroll = function(e) {
	if (e === void 0) return xa;
	if (e === !0 && xa) return xa.enable();
	if (e === !1) {
		xa && xa.kill(), xa = e;
		return;
	}
	var t = e instanceof na ? e : Ls(e);
	return xa && xa.target === t.target && xa.kill(), qa(t.target) && (xa = t), t;
}, $.core = {
	_getVelocityProp: Zi,
	_inputObserver: Ns,
	_scrollers: q,
	_proxies: Pi,
	bridge: {
		ss: function() {
			Ia || Zo("scrollStart"), Ia = Pa();
		},
		ref: function() {
			return da;
		}
	}
}, Ka() && J.registerPlugin($), hi.registerPlugin($);
var Rs = (e) => Math.max(0, Math.min(1, e)), zs = (e, t, n) => {
	let r = Rs((e - t) / (n - t));
	return r * r * (3 - 2 * r);
};
customElements.get("salty-sodium-story") || customElements.define("salty-sodium-story", class extends HTMLElement {
	connectedCallback() {
		this.abort = new AbortController(), this.media = matchMedia("(prefers-reduced-motion: reduce)"), this.stage = this.querySelector(".ss-story__stage");
		let e = this.closest(".page-wrapper");
		this.scroller = e && /auto|scroll/.test(getComputedStyle(e).overflowY) ? e : window, this.packet = this.querySelector("[data-packet]"), this.shadow = this.querySelector("[data-shadow]"), this.chapters = [...this.querySelectorAll("[data-chapter]")], this.buttons = [...this.querySelectorAll("[data-chapter-link]")], this.bars = [...this.querySelectorAll("[data-bar]")], this.motion = this.querySelector("[data-motion]"), this.progress = { value: 0 }, this.inView = !1, this.renderSamples = [], this.cutawayNote = this.querySelector("[data-cutaway-note]"), this.dataset.enhanced = "true", this.motion.addEventListener("click", () => {
			this.setStatic(this.dataset.static !== "true");
			let e = this.scroller === window ? scrollY : this.scroller.scrollTop;
			this.scroller.scrollTo({
				top: e + this.getBoundingClientRect().top - parseFloat(this.style.getPropertyValue("--story-top")),
				behavior: "instant"
			});
		}, { signal: this.abort.signal }), this.media.addEventListener("change", () => this.setStatic(this.media.matches), { signal: this.abort.signal }), this.buttons.forEach((e, t) => e.addEventListener("click", () => {
			let e = [
				.03,
				.42,
				.7,
				.97
			][t];
			this.dataset.static !== "true" && this.scroller.scrollTo({
				top: (this.scroller === window ? scrollY : this.scroller.scrollTop) + this.getBoundingClientRect().top - (this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top) - (parseFloat(this.style.getPropertyValue("--story-top")) || 0) + e * (this.offsetHeight - this.stage.offsetHeight - (this.exitHold || 0)),
				behavior: "smooth"
			});
		}, { signal: this.abort.signal })), document.addEventListener("scroll", () => this.onScroll(), { passive: !0, capture: !0, signal: this.abort.signal }), this.visibility = new IntersectionObserver((e) => {
			this.inView = e.some((e) => e.isIntersecting), this.scene?.setVisible(this.inView && this.dataset.static !== "true");
		}), this.visibility.observe(this.stage), this.loader = new IntersectionObserver((e) => {
			e.some((e) => e.isIntersecting) && !this.media.matches && this.loadScene();
		}, { rootMargin: "300px" }), this.loader.observe(this), this.resize = () => {
			let e = document.querySelector("header-component"), t = Math.max(60, Math.min(110, e?.getBoundingClientRect().height || 72)), n = document.getElementById("PBarNextFrame") ? 64 : 0, r = Math.max(530, Math.min(1100, innerHeight - t - n - 20));
			this.style.setProperty("--story-top", `${t}px`), this.style.setProperty("--story-height", `${r}px`), this.mobile = innerWidth <= 700, this.exitHold = this.dataset.static !== "true" && this.mobile ? Math.round(this.stage.offsetHeight * .65) : 0, this.style.setProperty("--story-exit-hold", `${this.exitHold}px`), this.paint(this.progress.value), this.onScroll();
		};
		let t;
		window.addEventListener("resize", () => {
			clearTimeout(t), t = setTimeout(() => {
				let t = e && /auto|scroll/.test(getComputedStyle(e).overflowY) ? e : window;
				this.resize(), t === this.scroller ? this.trigger?.refresh() : (this.scroller = t, this.setStatic(this.dataset.static === "true"));
			}, 180);
		}, { signal: this.abort.signal }), document.addEventListener("visibilitychange", () => {
			document.hidden || this.paint(this.progress.value);
		}, { signal: this.abort.signal }), this.resize(), this.setStatic(this.media.matches), document.fonts?.ready.then(() => {
			this.abort.signal.aborted || (this.resize(), this.trigger?.refresh());
		});
	}
	setStatic(e) {
		if (this.tween?.kill(), this.trigger?.kill(), this.trigger = null, this.dataset.static = String(e), this.motion.textContent = this.media.matches ? "Reduced motion" : e ? "Play motion" : "Pause motion", this.motion.disabled = this.media.matches, this.motion.setAttribute("aria-pressed", String(e)), this.chapters.forEach((e) => {
			e.inert = !1, e.removeAttribute("aria-hidden");
		}), e) {
			this.scene?.setVisible(!1);
			return;
		}
		this.progress.value = 0, this.target = 0, this.resize(), this.onScroll(), this.scene?.setVisible(this.inView), this.inView && this.loadScene();
	}
	// Pouch-story driver (2026-09-15): scroll sets a target, each frame eases 19% of the way to it.
	onScroll() {
		if (this.dataset.static === "true" || !this.stage) return;
		let e = this.closest(".page-wrapper");
		this.scroller = e && /auto|scroll/.test(getComputedStyle(e).overflowY) ? e : window;
		let t = this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top, n = parseFloat(this.style.getPropertyValue("--story-top")) || 0, r = this.offsetHeight - this.stage.offsetHeight - (this.exitHold || 0);
		this.target = r <= 0 ? 1 : Rs((n - (this.getBoundingClientRect().top - t)) / r);
		this.frame || (this.frame = requestAnimationFrame(() => this.tick()));
	}
	tick() {
		this.frame = 0;
		if (!this.abort || this.abort.signal.aborted || this.dataset.static === "true") return;
		let e = this.target - this.progress.value;
		this.progress.value = Math.abs(e) < 5e-4 ? this.target : this.progress.value + e * .19, this.paint(this.progress.value);
		this.progress.value !== this.target && (this.frame = requestAnimationFrame(() => this.tick()));
	}
	navRoom(a, o) {
		// the packet (and its "Illustrated interior" note) must end 14px above the chapter nav's hairline; on short laptop
		// windows (1366x657, 1440x680) the stage-height factor alone ran it across the nav (round-8 verifier, 2026-09-15)
		let e = this.querySelector(".ss-story__nav"), t = this.packet.offsetParent, n = e ? e.offsetHeight : 0, r = a + "x" + o + "x" + n;
		if (this.roomKey !== r) this.roomKey = r, this.room = e && t && n ? e.getBoundingClientRect().top - t.getBoundingClientRect().top - 14 : Infinity;
		return this.room;
	}
	paint(e) {
		if (this.dataset.static === "true") return;
		let t = zs(e, .16, .33), n = this.mobile ? zs(e, .52, .6) : zs(e, .8, .86), cmp = this.mobile ? 0 : zs(e, .54, .64), r = 1 - zs(e, .15, .24), i = zs(e, .24, .34) * (1 - zs(e, .52, .58));
		[
			r,
			i,
			zs(e, .58, .65) * (1 - zs(e, .78, .83)),
			zs(e, .83, .9)
		].forEach((e, t) => {
			if (!this.chapters[t]) return;
			hi.set(this.chapters[t], {
				autoAlpha: e,
				y: (1 - e) * (t === 0 ? -35 : 35)
			}), this.chapters[t].inert = e < .5, this.chapters[t].setAttribute("aria-hidden", String(e < .5));
		});
		let a = this.stage.clientWidth, o = this.stage.clientHeight, s = a * (this.mobile ? .46 : .46), d = o * (this.mobile ? .24 - .07 * t : .07), c = Math.min(o * (this.mobile ? .61 : .84), s * 3.85 / 1.9, this.navRoom(a, o) - d), l = a * (this.mobile ? .46 : .48), u = l + (a * (this.mobile ? .01 : .025) - l) * t;
		hi.set(this.packet, {
			left: 0,
			top: 0,
			width: s,
			height: c,
			x: u + (l - u) * cmp + n * a * .12,
			y: d + n * o * .05,
			xPercent: 0,
			yPercent: 0,
			rotation: 0,
			scale: 1 - n * .1,
			opacity: 1 - n
		}), hi.set(this.shadow, {
			left: u + (l - u) * cmp + s * .29,
			top: d + c * .96,
			width: s * .42,
			scale: 1 - n * .7,
			opacity: 1 - n
		}), this.bars.forEach((t, n) => hi.set(t, { scaleX: zs(e, .6 + n * .025, .72 + n * .025) }));
		let f = zs(e, .3, .46);
		hi.set(this.cutawayNote, { opacity: this.scene ? f * i : 0 });
		let p = e < .24 ? 0 : e < .56 ? 1 : e < .81 ? 2 : 3;
		if (this.dataset.chapter = String(p), this.dataset.progress = e.toFixed(3), this.buttons.forEach((e, t) => {
			t === p ? e.setAttribute("aria-current", "step") : e.removeAttribute("aria-current");
		}), hi.set(this.querySelector(".ss-story__scroll"), { opacity: 1 - n }), this.scene && this.inView && !document.hidden) {
			let n = performance.now();
			this.scene.setCutaway(f * (1 - cmp), e), this.scene.turn(-.045 * (1 - t), 0), this.renderSamples.length < 120 && this.renderSamples.push(performance.now() - n), this.renderSamples.length === 120 && (this.dataset.meanRenderMs = (this.renderSamples.reduce((e, t) => e + t, 0) / 120).toFixed(2));
		}
	}
	async loadScene() {
		if (this.loading || this.scene || this.dataset.static === "true") return;
		this.loading = !0;
		let e = this.abort.signal;
		try {
			let { mount: t } = await import(this.dataset.sceneModule);
			if (e.aborted) return;
			let n = await t(this.querySelector("[data-canvas]"), {
				original: this.dataset.original,
				caffeinated: this.dataset.caffeinated,
				syrup: this.dataset.syrup,
				version: this.dataset.variant,
				paused: !0,
				onVariant: () => {},
				onFailure: () => {
					this.dataset.scene = "failed", this.scene?.destroy(), this.scene = null;
				}
			});
			if (e.aborted) {
				n.destroy();
				return;
			}
			this.scene = n, this.dataset.scene = "ready", n.setVisible(this.inView && this.dataset.static !== "true"), this.paint(this.progress.value), this.loader.disconnect();
		} catch (e) {
			this.dataset.scene = "failed", console.warn("Salty sodium uses its packet poster:", e.message);
		} finally {
			this.loading = !1;
		}
	}
	disconnectedCallback() {
		this.abort?.abort(), this.visibility?.disconnect(), this.loader?.disconnect(), this.trigger?.kill(), this.tween?.kill(), this.scene?.destroy(), this.scene = null;
	}
});
//#endregion
